/* ---- utilitário: remove acentos -------------------------- */
function removeAccents(str){
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g,"").toLowerCase();
}

/* ---- Storefront API ------------------------------------- */
const STOREFRONT_TOKEN = "fa97136c54080ed5172dbc90cd512abf";
const GRAPHQL_URL      = "/api/2024-04/graphql.json";

/* carrega TODAS as coleções (250 por página) */
async function fetchAllCollections(){
  let list=[], endCursor=null, hasNextPage=true;
  while(hasNextPage){
    const query=`{
      collections(first:250${endCursor?`, after:"${endCursor}"`:""}){
        edges    { cursor node{ title handle } }
        pageInfo { hasNextPage endCursor }
      }
    }`;
    const r = await fetch(GRAPHQL_URL,{
      method:"POST",
      headers:{
        "Content-Type":"application/json",
        "X-Shopify-Storefront-Access-Token":STOREFRONT_TOKEN
      },
      body:JSON.stringify({query})
    }).then(r=>r.json());

    r.data.collections.edges.forEach(e=>list.push(e.node));
    hasNextPage = r.data.collections.pageInfo.hasNextPage;
    endCursor   = r.data.collections.pageInfo.endCursor;
  }
  return list;           // [{title,handle}, …]
}

/* cria faixa 0-9 / A-Z / Todos */
function createAlphaNav(){
  const nav   = document.getElementById("alphaNav");
  const chars = ["num",..."ABCDEFGHIJKLMNOPQRSTUVWXYZ","all"];
  chars.forEach(ch=>{
    const span=document.createElement("span");
    span.dataset.letter=ch;
    span.textContent   = ch==="num"?"0-9":ch==="all"?"Todos":ch;
    nav.appendChild(span);
  });
}

/* monta HTML da lista + botão X */
function showMatchList(matches){
  const items = matches.map(m=>
    `<li class="list-group-item">
       <a href="/collections/${m.handle}">${m.title}</a>
     </li>`).join("");

  $("#matchWrap").remove();          // remove lista anterior
  $("#searchForm").after(`
    <div id="matchWrap" class="match-wrap">
      <button type="button" class="match-close" title="Fechar"></button>
      <ul id="matchList" class="list-group mt-2">${items}</ul>
    </div>
  `);
}

/* scroll suave até o topo */
function scrollTopSmooth(){
  if("scrollBehavior" in document.documentElement.style){
    window.scrollTo({top:0,behavior:"smooth"});
  }else{
    $("html,body").animate({scrollTop:0},600);
  }
}

/* -------------------- INIT -------------------- */
document.addEventListener("DOMContentLoaded",async()=>{

  createAlphaNav();                           // 1) faixa A-Z
  const collections = await fetchAllCollections();   // 2) dados

  /* 3) autocomplete clássico */
  $("#collectionSearch").autocomplete({
    source: collections.map(c=>c.title)
  });

  /* ---------- BUSCA livre ---------- */
  function runSearch(){
    const term = removeAccents($("#collectionSearch").val().trim());
    if(!term) return;

    const matches = collections.filter(c =>
      removeAccents(c.title).includes(term)
    );

    if(matches.length===0){
      alert("Nenhuma coleção encontrada!");
    }else if(matches.length===1){
      window.location.href = `/collections/${matches[0].handle}`;
    }else{
      showMatchList(matches);
    }
  }

  /* botão Buscar (animação) */
  $("#searchButton").on("click",()=>{
    const btn=$("#searchButton");
    btn.addClass("run-effect");
    setTimeout(()=>{btn.removeClass("run-effect");runSearch();},1350);
  });

  /* ENTER → simula o clique */
  $("#collectionSearch").on("keydown",e=>{
    if(e.key==="Enter"){e.preventDefault();$("#searchButton").trigger("click");}
  });

  /* ---------- Faixa A-Z — click + touchstart ---------- */
  $("#alphaNav").on("touchstart click","span",function(e){
    e.preventDefault();          // evita duplo-tap e atraso
    if(e.type==="touchstart"){           // trata só uma vez
      $(this).data("touched",true);
      alphaSelect($(this));      // nossa função
      return;
    }
    if($(this).data("touched")){ // já tratou no touchstart
      $(this).removeData("touched");
      return;
    }
    alphaSelect($(this));
  });

  function alphaSelect($span){
    const letter=$span.data("letter");
    $("#alphaNav span").removeClass("active");
    $span.addClass("active");

    let filtered;
    if(letter==="all")        filtered=collections;
    else if(letter==="num")   filtered=collections.filter(c=>/^\d/.test(c.title));
    else                      filtered=collections.filter(c=>removeAccents(c.title)
                                  .startsWith(letter.toLowerCase()));

    if(filtered.length===0){
      alert("Nenhuma coleção encontrada!");
    }else if(filtered.length===1){
      window.location.href=`/collections/${filtered[0].handle}`;
    }else{
      showMatchList(filtered);
    }
  }

  /* ---------- botão × fecha + sobe ---------- */
  $(document).on("click",".match-close",()=>{
    $("#matchWrap").remove();
    scrollTopSmooth();
  });

});


(() => {
  const PULSE_TIME         = 4000;                     // ms
  const STORAGE_KEY_TERM   = 'collectionSearchTerm';
  const STORAGE_KEY_HINT   = 'pulseHintSeen';          // mostra só 1x
  const COLLECTION_LANDING = '/collections';
  const HINT_TEXT          = 'Toque novamente para ir à coleção';
  const HINT_LIFETIME      = 2600;                     // ms
  const SELECTOR           = '.tabs-categorys li a';

  const timeouts = new Map();

  function showOnceHintNear(el, text = HINT_TEXT, lifetime = HINT_LIFETIME){
    if (sessionStorage.getItem(STORAGE_KEY_HINT) === '1') return;
        sessionStorage.setItem(STORAGE_KEY_HINT, '1');

    const r = el.getBoundingClientRect();
    const bubble = document.createElement('div');
    bubble.textContent = text;
    bubble.setAttribute('role','status');

    Object.assign(bubble.style, {
      position:'fixed',
      left: (r.left + r.width/2) + 'px',
      top: (r.top - 10) + 'px',
      transform:'translate(-50%,-100%)',
      background:'rgba(0,0,0,.9)',
      color:'#fff',
      padding:'8px 10px',
      borderRadius:'8px',
      fontSize:'12px',
      lineHeight:'1.2',
      whiteSpace:'nowrap',
      boxShadow:'0 6px 18px rgba(0,0,0,.25)',
      zIndex:'9999',
      pointerEvents:'none',
      opacity:'0',
      transition:'opacity .2s, transform .2s'
    });

    document.body.appendChild(bubble);
    requestAnimationFrame(() => {
      bubble.style.opacity = '1';
      bubble.style.transform = 'translate(-50%,-110%)';
    });
    setTimeout(() => {
      bubble.style.opacity = '0';
      bubble.style.transform = 'translate(-50%,-90%)';
    }, Math.max(0, lifetime - 200));
    setTimeout(() => bubble.remove(), lifetime);
  }

  document.addEventListener('click', (evt) => {
    const link = evt.target.closest(SELECTOR);
    if (!link) return;

    const isPulsing = link.classList.contains('pulsando');

    /* SEGUNDO CLIQUE → ir para /collections */
    if (isPulsing) {
      evt.preventDefault(); // evita qualquer navegação do <a>
      const term = link.textContent.trim();
      localStorage.setItem(STORAGE_KEY_TERM, term);
      window.location.href = COLLECTION_LANDING;
      return;
    }

    /* PRIMEIRO CLIQUE → impede navegação, ativa pulso e mostra hint */
    evt.preventDefault(); // <- garante que não saia da página no 1º clique

    // limpa outros botões pulsando
    document.querySelectorAll(SELECTOR + '.pulsando').forEach(el => {
      el.classList.remove('pulsando');
      clearTimeout(timeouts.get(el));
      timeouts.delete(el);
    });

    // ativa pulso no clicado
    link.classList.add('pulsando');
    showOnceHintNear(link);

    const to = setTimeout(() => {
      link.classList.remove('pulsando');
      timeouts.delete(link);
    }, PULSE_TIME);
    timeouts.set(link, to);
  });
})();

(() => {
  const KEY = 'collectionSearchTerm';

  // tenta vários seletores comuns de busca
  const INPUT_SEL  = '#collectionSearch, input[type="search"][name="q"], input[type="search"], input#Search-In-Template';
  const BUTTON_SEL = '#searchButton, button[type="submit"][name="search"], form[role="search"] button[type="submit"]';

  function waitForEl(selector, timeout = 8000){
    return new Promise((resolve, reject) => {
      const found = document.querySelector(selector);
      if (found) return resolve(found);

      const obs = new MutationObserver(() => {
        const el = document.querySelector(selector);
        if (el) { obs.disconnect(); resolve(el); }
      });
      obs.observe(document.documentElement, { childList:true, subtree:true });
      setTimeout(() => { obs.disconnect(); reject(new Error('timeout')); }, timeout);
    });
  }

  function fireInputEvents(input){
    ['input','change'].forEach(t =>
      input.dispatchEvent(new Event(t, { bubbles:true }))
    );
  }
  function pressEnter(el){
    ['keydown','keypress','keyup'].forEach(t =>
      el.dispatchEvent(new KeyboardEvent(t, {
        key:'Enter', code:'Enter', keyCode:13, which:13, bubbles:true
      }))
    );
  }

  document.addEventListener('DOMContentLoaded', async () => {
    const term = localStorage.getItem(KEY);
    if (!term) return;

    try {
      // espera o input existir (tema pode hidratar depois)
      const input = await waitForEl(INPUT_SEL, 8000);
      input.focus();
      input.value = term;
      fireInputEvents(input);

      // tenta botão; se não tiver, manda Enter no input
      const btn = document.querySelector(BUTTON_SEL);
      if (btn) {
        ['mousedown','mouseup','click'].forEach(evt =>
          btn.dispatchEvent(new MouseEvent(evt, { bubbles:true, cancelable:true }))
        );
      } else {
        pressEnter(input);
      }
    } catch (e) {
      // último recurso: adiciona ?q=term na URL
      try {
        const u = new URL(location.href);
        u.searchParams.set('q', term);
        location.replace(u.toString());
      } catch(_) {}
    } finally {
      localStorage.removeItem(KEY);
    }
  });
})();



/* =========================================================
   AFB — FUNKO MIN (só Funko) + BRINDE POR FAIXA + BUY NOW
   - Toast Funko aparece APENAS em Funko (e só quando faz sentido)
   - Contador sincronizado (hook fetch + XHR)
   - ✅ Barra ULTRA SMOOTH (scaleX, sem flicker)
   - ✅ Toast NÃO re-renderiza (skeleton fixo; só atualiza partes)
   - ✅ Transição premium de tiers (stepper + passos compactos + final detalhado)
   - ✅ Confete premium (só no final, com delay)
   - ✅ Compre Já (Funko): tenta ATC NATIVO do tema p/ mini-cart atualizar
   - ✅ SEM reload: ao voltar do checkout (bfcache), apenas recheck/sync leve
   - ✅ NÃO mexe mais no remove do mini-cart (isso fica no script do tema)
========================================================= */
(function () {
  if (window.AFB_FUNKO_MIN_LOADED) return;
  window.AFB_FUNKO_MIN_LOADED = true;

  // =========================
  // CONFIG
  // =========================
  var MIN_FUNKO_QTY = 5;
  var MODE = "only_funko"; // "strict" ou "only_funko"

  var ENABLE_GIFT_TOAST = true;

  // ✅ CUPONS POR TIER
  var COUPON_PRATA_CODE = "ColecionadorPrata"; // PopChain / chaveiros (>= 1500)
  var COUPON_GOLD_CODE  = "ColecionadorGold";  // Funko Pop (>= 2000)

  var COUPON_PRATA_MIN_CENTS = 150000; // R$ 1.500,00
  var COUPON_GOLD_MIN_CENTS  = 200000; // R$ 2.000,00

  // ✅ Inteirar com Funko (só pra fechar o GAP do próximo tier)
  var TOPUP_WITH_FUNKO_ENABLED = true;
  var TOPUP_CLOSE_GAP_MAX_CENTS = 30000; // X reais (ex: 300,00)

  // ✅ aplica cupom no background (cookie) quando elegível
  var GIFT_AUTO_APPLY_COUPON = true;

  // BuyNow (não-Funko)
  var BUYNOW_PROGRESS_MS = 15000; // 15s
  var BUYNOW_SHOW_ONLY_IF_PRICE_GE_CENTS = 0; // ex: 200000 p/ >= 2000

  // ✅ Funko BuyNow (quando carrinho é só Funko e não tem brinde)
  var FUNKO_BUYNOW_CONFIRM_MS = 900;

  // Brindes por faixa (baseado no TOTAL elegível)
  // (mantenha em ordem do maior pro menor, por segurança)
  var GIFT_TIERS = [
    { key: "2k",  minCents: 200000, giftLabel: "1 Funko Pop Original",                 couponCode: "ColecionadorGold",  choosePath: "/collections/funko" },
    { key: "15",  minCents: 150000, giftLabel: "1 PopChain (Chaveiro Funko Pop)",      couponCode: "ColecionadorPrata", choosePath: "/collections/chaveiro-funko-pop" },
    { key: "10",  minCents: 100000, giftLabel: "1 Chaveiro ActionFigureBrasil + 1 HQ Panini", couponCode: "", choosePath: "" },
    { key: "low", minCents: 0,      giftLabel: "1 Chaveiro ActionFigureBrasil",        couponCode: "", choosePath: "" }
  ];

  // Não mostrar bloqueio passivo no site todo
  var PASSIVE_BLOCK_TOAST = false;

  // Se fechar, não reaparece até carrinho mudar
  var TOAST_RESPECT_CLOSE_UNTIL_CART_CHANGE = true;

  // Toast de brinde: só em mudança de carrinho
  var GIFT_TOAST_ONLY_ON_CART_CHANGE = true;

  // Vendors / palavras Funko
  var FUNKO_VENDOR_KEYWORDS = ["funko", "funko/ホットトイズ", "funko pop"];

  // Toast de Funko (ao adicionar no carrinho)
  var FUNKO_ATC_AUTOHIDE_MS = 6500;

  // confete quando liberar brinde “escolhível” (PopChain/Funko Pop)
  var ENABLE_GIFT_CONFETTI = true;

  // =========================
  // SELECTORS
  // =========================
  var CHECKOUT_SELECTORS = [
    '[name="checkout"]',
    'button[name="checkout"]',
    'input[name="checkout"]',
    'a[href*="/checkout"]',
    'a[href*="/checkouts/"]',
    'form[action*="/checkout"]',
    'form[action*="/checkouts/"]',
    '.btn-checkout',
    '.cart__checkout',
    '.checkout-button',
    'button.checkout',
    'a.checkout'
  ].join(",");

  var ADD_TO_CART_SELECTORS = [
    'form[action^="/cart/add"]',
    'button[name="add"]',
    'button[type="submit"][name="add"]',
    'button.add-to-cart',
    '.add-to-cart',
    '[data-add-to-cart]',
    '[data-add-to-cart-button]',
    '.product-form__submit',
    '.product-form__cart-submit',
    'button[type="submit"][form*="product"]',
    '#button-cart',
    '#button-cart-sticky'
  ].join(",");

  var BUY_NOW_SELECTORS = [
    "#button-cart-buy",
    ".shopify-payment-button__button",
    ".shopify-payment-button button",
    ".shopify-payment-button [type='submit']",
    'button[name="checkout"]',
    'input[name="checkout"]',
    '.btn-buy-now',
    '.buy-now',
    '[data-buy-now]'
  ].join(",");

  // =========================
  // STORAGE KEYS
  // =========================
  var SS_CLOSED_FP = "AFB_FUNKO_TOAST_CLOSED_FP";
  var SS_GIFT_SHOWN = "AFB_GIFT_SHOWN_FP_KIND";
  var SS_DISCOUNT_APPLIED = "AFB_GIFT_DISCOUNT_APPLIED_FP_CODE";

  function ssGet(key){ try { return sessionStorage.getItem(key); } catch(e){ return null; } }
  function ssSet(key,val){ try { sessionStorage.setItem(key,val); } catch(e){} }

  function markToastClosedForFp(fp){ ssSet(SS_CLOSED_FP, String(fp || "")); }
  function isToastClosedForFp(fp){ return ssGet(SS_CLOSED_FP) === String(fp || ""); }

  function getGiftShownMap(){
    try { return JSON.parse(ssGet(SS_GIFT_SHOWN) || "{}"); } catch(e){ return {}; }
  }
  function markGiftShown(fp, kind){
    var m = getGiftShownMap();
    m[String(fp||"") + "|" + String(kind||"")] = 1;
    ssSet(SS_GIFT_SHOWN, JSON.stringify(m));
  }
  function wasGiftShown(fp, kind){
    var m = getGiftShownMap();
    return !!m[String(fp||"") + "|" + String(kind||"")];
  }

  function getDiscountAppliedMap(){
    try { return JSON.parse(ssGet(SS_DISCOUNT_APPLIED) || "{}"); } catch(e){ return {}; }
  }
  function markDiscountApplied(fp, code){
    var m = getDiscountAppliedMap();
    m[String(fp||"") + "|" + String(code||"")] = Date.now();
    ssSet(SS_DISCOUNT_APPLIED, JSON.stringify(m));
  }
  function wasDiscountApplied(fp, code){
    var m = getDiscountAppliedMap();
    return !!m[String(fp||"") + "|" + String(code||"")];
  }

  // =========================
  // STATE
  // =========================
  var AFB_TOAST_CLOSED = false;
  var AFB_LAST_CART_FINGERPRINT = "";
  var AFB_LAST_SHOWN_KIND = "";
  var AFB_AUTOHIDE_TIMER = null;

  var AFB_RECHECK_TIMER = null;
  var AFB_RECHECK_CHAIN = Promise.resolve();

  var AFB_BUYNOW_ACTIVE = false;
  var AFB_BUYNOW_T = null;
  // ===== BuyNow UX helpers (15s + botões) =====
var AFB_BUYNOW_COUNTDOWN_I = null;

function cancelBuyNowFlow() {
  try { if (AFB_BUYNOW_T) { clearTimeout(AFB_BUYNOW_T); AFB_BUYNOW_T = null; } } catch(e){}
  try { if (AFB_BUYNOW_COUNTDOWN_I) { clearInterval(AFB_BUYNOW_COUNTDOWN_I); AFB_BUYNOW_COUNTDOWN_I = null; } } catch(e){}
  try { AFB_BUYNOW_ACTIVE = false; } catch(e){}
  try { window.__AFB_BUYNOW_ADD_PROMISE = null; } catch(e){}
}

function startBuyNowCountdown(seconds) {
  try { if (AFB_BUYNOW_COUNTDOWN_I) clearInterval(AFB_BUYNOW_COUNTDOWN_I); } catch(e){}
  var left = Math.max(0, parseInt(seconds, 10) || 0);

  function paint() {
    var box = document.getElementById("afbFunkoMinBox");
    if (!box) return;
    var nodes = box.querySelectorAll("[data-afb-countdown-num]");
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = String(left);
  }

  paint();
  if (!left) return;

  AFB_BUYNOW_COUNTDOWN_I = setInterval(function () {
    left = Math.max(0, left - 1);
    paint();
    if (left <= 0) {
      try { clearInterval(AFB_BUYNOW_COUNTDOWN_I); } catch(e){}
      AFB_BUYNOW_COUNTDOWN_I = null;
    }
  }, 1000);
}

function playMaxTierLadder(box) {
  if (!box) return;
  var stepper = box.querySelector('.afb-gift-stepper[data-afb-tier-ladder="1"]');
  if (!stepper) return;

  var steps = stepper.querySelectorAll(".afb-gift-step");
  if (!steps || !steps.length) return;

  for (var i = 0; i < steps.length; i++) {
    steps[i].classList.remove("afb-ladder-on");
  }

  for (var j = 0; j < steps.length; j++) {
    (function(idx){
      setTimeout(function(){
        // “acende” um por um
        try { steps[idx].classList.add("afb-ladder-on"); } catch(e){}
      }, 220 * idx);
    })(j);
  }

  // limpa o brilho depois
  setTimeout(function(){
    for (var k = 0; k < steps.length; k++) {
      steps[k].classList.remove("afb-ladder-on");
    }
  }, (steps.length * 220) + 900);
}

  // trava clicks repetidos do Compre Já (Funko)
  var AFB_FUNKO_BUY_LOCK = false;

  // marca “acabou de adicionar no carrinho”
  var AFB_LAST_CART_ADD_TS = 0;

  // cache do último estado
  window.__AFB_FUNKO_LAST_STATE = window.__AFB_FUNKO_LAST_STATE || null;

  // controle de animação de tiers
  window.__AFB_GIFT_ANIM_ID = window.__AFB_GIFT_ANIM_ID || 0;

  // =========================
  // HELPERS
  // =========================
  function escapeHtml(s){
    return String(s)
      .replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;")
      .replace(/"/g,"&quot;").replace(/'/g,"&#39;");
  }

  function isGiftSelectionPage(){
  try {
    var p = location.pathname || "";

    // normaliza trailing slash
    if (p.length > 1 && p.endsWith("/")) {
      p = p.slice(0, -1);
    }

    return (
      // 🔒 raiz da collections (somente ela)
      p === "/collections" ||

      // 🔒 páginas de escolha de brinde
      p.startsWith("/collections/funko") ||
      p.startsWith("/collections/funko-deluxe") ||
      p.startsWith("/collections/popchain") ||
      p.startsWith("/collections/chaveiro-funko-pop") ||

      // 🔒 login (opcional)
      p.startsWith("/account/login")
    );
  } catch(e){
    return false;
  }
}





  function plural(n, one, many){
    return (Number(n) === 1) ? one : many;
  }

  function moneyBRL(cents){
    try{
      return new Intl.NumberFormat("pt-BR", { style:"currency", currency:"BRL" }).format((Number(cents||0)/100));
    }catch(e){
      return "R$ " + ((Number(cents||0)/100).toFixed(2)).replace(".", ",");
    }
  }

  function matchesAny(el, selectors){
    try{ return !!(el && el.matches && el.matches(selectors)); }catch(e){ return false; }
  }

  function discountLink(code, path){
    if (!code) return path || "/";
    var p = path || "/";
    return "/discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(p);
  }

  function isLikelyProductPage(){
    try{
      var sa = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page;
      if (sa && sa.pageType) return String(sa.pageType) === "product";
    }catch(e){}
    return !!document.querySelector('form[action^="/cart/add"], form[action*="/cart/add"]');
  }

  function isFunkoItem(item) {
    var v = String(item.vendor || "").toLowerCase();
    var t = String(item.product_type || "").toLowerCase();
    var title = String(item.product_title || item.title || "").toLowerCase();
    var handle = String(item.handle || "").toLowerCase();

    for (var i = 0; i < FUNKO_VENDOR_KEYWORDS.length; i++) {
      if (v.indexOf(FUNKO_VENDOR_KEYWORDS[i]) !== -1) return true;
    }
    if (t.indexOf("funko") !== -1) return true;
    if (title.indexOf("funko") !== -1) return true;
    if (handle.indexOf("funko") !== -1) return true;

    return false;
  }

  // Detecção de Funko na PÁGINA (pra BuyNow / ATC)
  function detectPageVendorText(){
    try{
      var mp = (window.meta && window.meta.product) ? window.meta.product : null;
      if (mp && (mp.vendor || mp.type)) return String(mp.vendor || mp.type || "");
    }catch(e){}

    try{
      var sa = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
      if (sa && (sa.vendor || sa.type)) return String(sa.vendor || sa.type || "");
    }catch(e){}

    // JSON-LD
    try{
      var ld = document.querySelectorAll('script[type="application/ld+json"]');
      for (var i=0;i<ld.length;i++){
        var obj = JSON.parse(ld[i].textContent || "{}");
        if (obj && obj["@type"] === "Product"){
          if (obj.brand && obj.brand.name) return String(obj.brand.name);
          if (obj.manufacturer && obj.manufacturer.name) return String(obj.manufacturer.name);
        }
      }
    }catch(e){}

    // DOM comum
    var el =
      document.querySelector('[itemprop="brand"]') ||
      document.querySelector('.manufacture-product') ||
      document.querySelector('.product-vendor') ||
      document.querySelector('[data-vendor]') ||
      null;

    if (el) return (el.textContent || el.getAttribute("data-vendor") || "").trim();

    // fallback leve
    var txt = (document.querySelector(".box-options") || document.body).innerText || "";
    return txt;
  }

  function isFunkoProductPage() {
    var t = String(detectPageVendorText() || "").toLowerCase();
    return t.indexOf("funko") !== -1;
  }

  function getProductQty() {
    var el =
      document.querySelector('form[action^="/cart/add"] input[name="quantity"]') ||
      document.querySelector('input[name="quantity"]') ||
      document.getElementById("Quantity") ||
      document.querySelector(".qty input") ||
      null;

    var n = el ? parseInt(el.value, 10) : 1;
    return isFinite(n) && n > 0 ? n : 1;
  }

  function setProductQty(qty){
    try{
      var el =
        document.querySelector('form[action^="/cart/add"] input[name="quantity"]') ||
        document.querySelector('input[name="quantity"]') ||
        document.getElementById("Quantity") ||
        document.querySelector(".qty input") ||
        null;
      if (!el) return;
      el.value = String(qty || 1);
      try{ el.dispatchEvent(new Event("input", {bubbles:true})); }catch(e){}
      try{ el.dispatchEvent(new Event("change", {bubbles:true})); }catch(e){}
    }catch(e){}
  }

  function getCurrentVariantId(){
    var el =
      document.querySelector('form[action^="/cart/add"] [name="id"]') ||
      document.querySelector('form[action*="/cart/add"] [name="id"]') ||
      document.querySelector('input[name="id"]');

    var v = el ? String(el.value || "").trim() : "";
    return v && /^\d+$/.test(v) ? v : "";
  }

  function parseMoneyToCents(raw){
    if (raw == null) return 0;
    var s = String(raw).trim();
    if (!s) return 0;

    if (/^\d+(\.\d+)?$/.test(s)) {
      var f1 = parseFloat(s);
      return isFinite(f1) ? Math.round(f1 * 100) : 0;
    }

    s = s.replace(/[^\d,.\-]/g, "");
    if (!s) return 0;
    if (s.indexOf(",") !== -1) s = s.replace(/\./g, "").replace(",", ".");
    var f = parseFloat(s);
    return isFinite(f) ? Math.round(f * 100) : 0;
  }

  function getCurrentProductPriceCents(){
    var metaPrice = document.querySelector('meta[property="product:price:amount"]');
    if (metaPrice && metaPrice.content) return parseMoneyToCents(metaPrice.content);

    var ip = document.querySelector('[itemprop="price"]');
    if (ip) {
      var c = ip.getAttribute("content");
      if (c) return parseMoneyToCents(c);
      var tx = ip.textContent;
      if (tx) return parseMoneyToCents(tx);
    }

    var ld = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i=0;i<ld.length;i++){
      try{
        var obj = JSON.parse(ld[i].textContent || "{}");
        var offers = obj && obj.offers ? obj.offers : null;
        if (offers) {
          if (Array.isArray(offers) && offers[0] && offers[0].price != null) return parseMoneyToCents(offers[0].price);
          if (!Array.isArray(offers) && offers.price != null) return parseMoneyToCents(offers.price);
        }
      }catch(e){}
    }

    var priceEl =
      document.querySelector('.product-info .price, .product-info .special-price, .product-info .money') ||
      document.querySelector('.price-box .price, .price-box .special-price, .price-box .money') ||
      document.querySelector('.price .money, .money');

    if (priceEl) return parseMoneyToCents(priceEl.textContent);
    return 0;
  }

  function fetchCart() {
    return fetch("/cart.js?ts=" + Date.now(), {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    }).then(function (r) {
      if (!r.ok) throw new Error("cart fetch failed");
      return r.json();
    });
  }

  function cartFingerprint(cart){
    try{
      var parts = (cart.items || []).map(function(it){ return String(it.id) + ":" + String(it.quantity||0); });
      parts.sort();
      return parts.join("|");
    }catch(e){
      return String(Date.now());
    }
  }

  function addToCartByVariant(variantId, qty){
    var body = new URLSearchParams();
    body.append("id", variantId);
    body.append("quantity", String(qty || 1));

    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
      },
      body: body.toString()
    }).then(function(r){
      if (!r.ok) throw new Error("add failed");
      return r.json();
    });
  }

  function gotoCheckoutWithDiscount(code){
    try{
      if (code) window.location.href = "/discount/" + encodeURIComponent(code) + "?redirect=/checkout";
      else window.location.href = "/checkout";
    }catch(e){
      window.location.href = "/checkout";
    }
  }

  function applyCheckout(blocked){
    var nodes = document.querySelectorAll(CHECKOUT_SELECTORS);
    for (var i=0;i<nodes.length;i++){
      var el = nodes[i];
      var tag = (el.tagName || "").toLowerCase();
      if (tag === "form") continue;

      if (tag === "a") {
        if (blocked) {
          el.classList.add("afb-checkout-disabled");
          el.setAttribute("aria-disabled", "true");
        } else {
          el.classList.remove("afb-checkout-disabled");
          el.removeAttribute("aria-disabled");
        }
      } else {
        el.disabled = !!blocked;
        if (blocked) el.classList.add("afb-checkout-disabled");
        else el.classList.remove("afb-checkout-disabled");
      }
    }
  }

  function pickGiftTier(totalCents){
    var v = Math.max(0, Number(totalCents || 0));
    for (var i=0;i<GIFT_TIERS.length;i++){
      if (v >= GIFT_TIERS[i].minCents) return GIFT_TIERS[i];
    }
    return GIFT_TIERS[GIFT_TIERS.length - 1];
  }

  function nextGiftTier(totalCents){
    var v = Math.max(0, Number(totalCents || 0));
    var sorted = GIFT_TIERS.slice().sort(function(a,b){ return a.minCents - b.minCents; });
    for (var i=0;i<sorted.length;i++){
      if (v < sorted[i].minCents) return sorted[i];
    }
    return null;
  }

  function getDiscountCodeForTotal(totalCents){
    var v = Number(totalCents || 0);
    if (v >= COUPON_GOLD_MIN_CENTS) return COUPON_GOLD_CODE;
    if (v >= COUPON_PRATA_MIN_CENTS) return COUPON_PRATA_CODE;
    return "";
  }

  function autoApplyDiscountInBackground(code, fp){
    if (!GIFT_AUTO_APPLY_COUPON) return;
    if (!code) return;
    if (!document || !document.body) return;
    if (wasDiscountApplied(fp || "", code)) return;

    try{
      var ifr = document.createElement("iframe");
      ifr.setAttribute("aria-hidden","true");
      ifr.tabIndex = -1;
      ifr.style.cssText = "position:absolute;width:1px;height:1px;left:-9999px;top:-9999px;opacity:0;pointer-events:none;";
      ifr.src = "/discount/" + encodeURIComponent(code) + "?redirect=/cart";
      document.body.appendChild(ifr);

      markDiscountApplied(fp || "", code);

      setTimeout(function(){
        try{ ifr.remove(); }catch(e){}
      }, 3500);
    }catch(e){}
  }

  // =========================
  // “Inteirar com Funko”
  // =========================
  function computeGiftEligibility(baseCents, cartTotalCents){
    baseCents = Math.max(0, Number(baseCents || 0));
    cartTotalCents = Math.max(0, Number(cartTotalCents || 0));

    var funkoTotalCents = Math.max(0, cartTotalCents - baseCents);

    var eligibleCents = baseCents;
    var topupUsedCents = 0;
    var topupGapCents = 0;
    var topupPossible = false;

    var nextT_for_base = nextGiftTier(baseCents);

    if (TOPUP_WITH_FUNKO_ENABLED && nextT_for_base && Number(nextT_for_base.minCents || 0) > baseCents) {
      topupGapCents = Math.max(0, Number(nextT_for_base.minCents) - baseCents);

      if (topupGapCents > 0 && topupGapCents <= TOPUP_CLOSE_GAP_MAX_CENTS) {
        topupPossible = true;
        topupUsedCents = Math.min(funkoTotalCents, topupGapCents);
        eligibleCents = baseCents + topupUsedCents;
      }
    }

    return {
      cartTotalCents: cartTotalCents,
      funkoTotalCents: funkoTotalCents,
      eligibleCents: eligibleCents,
      topupUsedCents: topupUsedCents,
      topupGapCents: topupGapCents,
      topupPossible: topupPossible
    };
  }

  // =========================
  // THEME CART REFRESH (best-effort)
  // =========================
  function dispatchCartSignals(cart){
    var names = [
      "cart:refresh",
      "cart:updated",
      "cart:change",
      "cart:render",
      "ajaxCart:refresh",
      "ajaxCart:updated",
      "drawer:refresh"
    ];
    for (var i=0;i<names.length;i++){
      try{ window.dispatchEvent(new CustomEvent(names[i], { detail:{ cart: cart||null } })); }catch(e){}
      try{ document.dispatchEvent(new CustomEvent(names[i], { detail:{ cart: cart||null } })); }catch(e){}
    }

    try{
      if (window.jQuery) {
        var $ = window.jQuery;
        $(document).trigger("cart:refresh", [cart]);
        $(document).trigger("cart:updated", [cart]);
        $(document).trigger("ajaxCart:refresh", [cart]);
        $(document).trigger("ajaxCart:updated", [cart]);
        $(document).trigger("drawer:refresh", [cart]);
      }
    }catch(e){}

    try{
      var count = cart && cart.item_count != null ? String(cart.item_count) : "";
      var nodes = document.querySelectorAll(
        '[data-cart-count], .cart-count, .cartCount, .header__cart-count, .site-header__cart-count, .mini-cart-count'
      );
      for (var j=0;j<nodes.length;j++){
        var n = nodes[j];
        try{
          if ("value" in n) n.value = count;
          else n.textContent = count;
        }catch(e2){}
      }
    }catch(e){}
  }

  // =========================
  // ATC NATIVO (para o tema atualizar o mini-cart)
  // =========================
  function findNativeAtcButton(){
    var form = document.querySelector('form[action^="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;

    var candidates = form.querySelectorAll(
      'button[name="add"], button[type="submit"][name="add"], [data-add-to-cart], [data-add-to-cart-button], .product-form__submit, #button-cart, #button-cart-sticky, button[type="submit"]'
    );
    for (var i=0;i<candidates.length;i++){
      var b = candidates[i];
      if (!b) continue;
      if (matchesAny(b, BUY_NOW_SELECTORS)) continue;
      return b;
    }
    return null;
  }

  function triggerNativeAddToCart(qty){
    return new Promise(function(resolve){
      var form = document.querySelector('form[action^="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      var btn  = findNativeAtcButton();

      if (!form && !btn) return resolve(false);

      setProductQty(qty || 1);

      if (btn && btn.click) {
        try{
          btn.click();
          return resolve(true);
        }catch(e){}
      }

      if (form) {
        try{
          var ev = new Event("submit", { bubbles:true, cancelable:true });
          var prevented = !form.dispatchEvent(ev);
          if (prevented) return resolve(true);
          try{ form.submit(); }catch(e2){}
          return resolve(true);
        }catch(e3){}
      }

      resolve(false);
    });
  }

  function waitCartChangesFromFp(prevFp, timeoutMs){
    timeoutMs = timeoutMs || 2200;
    var start = Date.now();

    function step(){
      return fetchCart().then(function(cart){
        var fp = cartFingerprint(cart);
        if (fp !== prevFp) return { changed:true, cart:cart };
        if ((Date.now() - start) >= timeoutMs) return { changed:false, cart:cart };
        return new Promise(function(res){
          setTimeout(function(){ res(step()); }, 250);
        });
      }).catch(function(){
        return { changed:false, cart:null };
      });
    }

    return step();
  }

  // =========================
  // UI: styles (1x)
  // =========================
  function ensureToastStyles(){
    if (window.__AFB_FUNKO_TOAST_STYLES) return;
    window.__AFB_FUNKO_TOAST_STYLES = true;

    try{
      var css = ""
        + "#afbFunkoMinBox{ position:fixed; left:50%; transform:translateX(-50%); z-index:999999; }"
        + "#afbFunkoMinBox.is-hidden{ display:none !important; }"
        + "#afbFunkoMinBox .afb-funko-progress{ display:block; width:100%; height:10px; border-radius:999px; overflow:hidden; }"
        + "#afbFunkoMinBox .afb-funko-progress i{ display:block; width:100% !important; height:100%; transform-origin:left center; transform:scaleX(0); will-change:transform; }"
        + "#afbFunkoMinBox .afb-funko-counterLabel{ font-size:12px; opacity:.85; margin:8px 0 8px; }"

        + "#afbFunkoMinBox .afb-gift-stepper{ display:flex; flex-wrap:wrap; gap:10px; margin:8px 0 6px; }"
        + "#afbFunkoMinBox .afb-gift-step{ display:flex; align-items:center; gap:6px; font-size:12px; opacity:.78; }"
        + "#afbFunkoMinBox .afb-gift-dot{ width:8px; height:8px; border-radius:999px; background:rgba(255,255,255,.22); }"
        + "#afbFunkoMinBox .afb-gift-step.is-done{ opacity:.92; }"
        + "#afbFunkoMinBox .afb-gift-step.is-done .afb-gift-dot{ background:rgba(255,214,0,.95); box-shadow:0 0 12px rgba(255,214,0,.18); }"
        + "#afbFunkoMinBox .afb-gift-step.is-active{ opacity:1; font-weight:800; }"
        + "#afbFunkoMinBox .afb-gift-step.is-active .afb-gift-dot{ background:rgba(255,43,247,.98); box-shadow:0 0 12px rgba(255,43,247,.18); }"
        + "#afbFunkoMinBox .afb-funko-actions .afb-funko-btn--ghost{ background:rgba(255,255,255,.06) !important; border:1px solid rgba(255,255,255,.16) !important; }"
        + "#afbFunkoMinBox .afb-funko-actions .afb-funko-btn--ghost:hover{ background:rgba(255,255,255,.10) !important; }"
        + "#afbFunkoMinBox .afb-buynowline{ margin-top:8px; opacity:.92; }"
        + "#afbFunkoMinBox .afb-gift-step.afb-ladder-on{ opacity:1 !important; transform:translateY(-1px); }"
        + "#afbFunkoMinBox .afb-gift-step.afb-ladder-on .afb-gift-dot{ background:rgba(255,214,0,.98) !important; box-shadow:0 0 16px rgba(255,214,0,.28) !important; }"

        + "#afbFunkoMinBox .afb-confetti{ position:absolute; inset:0; pointer-events:none; overflow:visible; }"
        + "#afbFunkoMinBox .afb-confetti-piece{ position:absolute; top:-10px; border-radius:3px; opacity:.95;"
        + " animation: afbConfettiFall var(--dur, 1400ms) cubic-bezier(.22,1,.36,1) forwards; }"
        + "@keyframes afbConfettiFall{"
        + " 0%{ transform: translate3d(var(--x,0px),0,0) rotate(0deg); opacity:0; }"
        + " 10%{opacity:1;} "
        + " 100%{ transform: translate3d(var(--x,0px), var(--y, 220px), 0) rotate(var(--r, 520deg)); opacity:0; }"
        + "}";

      var st = document.createElement("style");
      st.id = "afbFunkoToastPremiumStyle";
      st.appendChild(document.createTextNode(css));
      document.head.appendChild(st);
    }catch(e){}
  }

  // =========================
  // UI: toast skeleton (NO re-render)
  // =========================
  function ensureToastBox(){
    ensureToastStyles();

    var box = document.getElementById("afbFunkoMinBox");
    if (!box){
      box = document.createElement("div");
      box.id = "afbFunkoMinBox";
      box.className = "is-hidden";
      box.style.display = "none";
      document.body.appendChild(box);
    }

    if (!box.querySelector(".afb-funko-msg")){
      box.innerHTML =
        "<div class='afb-funko-msg' role='status' aria-live='polite'>" +
          "<div class='afb-funko-head'>" +
            "<button type='button' class='afb-funko-icbtn' aria-label='Informações'>i</button>" +
            "<div class='afb-funko-title'></div>" +
            "<button type='button' class='afb-funko-close' aria-label='Fechar aviso'>×</button>" +
          "</div>" +
          "<div class='afb-funko-content'>" +
            "<div class='afb-funko-main'></div>" +
            "<div class='afb-funko-actions'></div>" +
            "<div class='afb-funko-counter'>" +
              "<div class='afb-funko-counterLabel'></div>" +
              "<span class='afb-funko-progress' aria-hidden='true'><i></i></span>" +
            "</div>" +
            "<div class='afb-funko-tip'></div>" +
          "</div>" +
        "</div>";
    }

    return box;
  }

  function hideToast(){
    var box = document.getElementById("afbFunkoMinBox");
    if (!box) return;
    box.classList.add("is-hidden");
    box.style.display = "none";
  }

  function clearAutoHide(){
    if (AFB_AUTOHIDE_TIMER) { clearTimeout(AFB_AUTOHIDE_TIMER); AFB_AUTOHIDE_TIMER = null; }
  }

  function colorForPct(pct){
    var p = Math.max(0, Math.min(100, Number(pct||0))) / 100;
    var h;
    if (p < 0.70) h = 285 + (330 - 285) * (p / 0.70);
    else h = 330 + (50 - 330) * ((p - 0.70) / 0.30);
    return "hsl(" + h.toFixed(1) + " 92% 56%)";
  }

  function ensureProgressReset(){
    var box = document.getElementById("afbFunkoMinBox");
    if (!box) return;
    var bar = box.querySelector(".afb-funko-progress i");
    if (!bar) return;

    try{ box.dataset.lastPct = "0"; }catch(e){}

    bar.style.transition = "none";
    bar.style.transform = "scaleX(0)";
    bar.style.background = "linear-gradient(90deg, rgba(255,43,247,.98), " + colorForPct(0) + ")";
    bar.style.boxShadow = "none";

    requestAnimationFrame(function(){
      bar.style.transition = "transform 560ms cubic-bezier(.22,1,.36,1)";
    });
  }

  function animateProgress(kind, targetPct, opts){
    opts = opts || {};
    var box = document.getElementById("afbFunkoMinBox");
    if (!box) return;

    var bar = box.querySelector(".afb-funko-progress i");
    if (!bar) return;

    var pct = Math.max(0, Math.min(100, Number(targetPct || 0)));
    var cur = parseFloat(String(box.dataset.lastPct || "0")) || 0;

    var monotonic = (opts.monotonic != null) ? !!opts.monotonic : true;
    if (monotonic && String(box.dataset.kind || "") === String(kind || "")) {
      pct = Math.max(pct, cur);
    }

    var fromPct = (typeof opts.fromPct === "number") ? Math.max(0, Math.min(100, opts.fromPct)) : cur;

    try{ box.dataset.lastPct = String(pct); }catch(e){}

    if (opts.forceColor) {
      bar.style.background = "linear-gradient(90deg, " + opts.forceColor + ", " + opts.forceColor + ")";
      bar.style.boxShadow = opts.forceGlow ? "0 0 18px rgba(255,214,0,.35), 0 0 40px rgba(255,214,0,.18)" : "none";
    } else {
      bar.style.background = "linear-gradient(90deg, rgba(255,43,247,.98), " + colorForPct(pct) + ")";
      bar.style.boxShadow = "none";
    }

    var dur = Number(opts.durationMs || 560);

    // set start
    bar.style.transition = "none";
    bar.style.transform = "scaleX(" + (fromPct/100) + ")";
    bar.getBoundingClientRect();

    // animate
    bar.style.transition = "transform " + dur + "ms cubic-bezier(.22,1,.36,1)";
    requestAnimationFrame(function(){
      bar.style.transform = "scaleX(" + (pct/100) + ")";
    });
  }

  function syncToastTop(){
    var box = document.getElementById("afbFunkoMinBox");
    if (!box) return;

    var anchor =
      document.getElementById("afbAddToast") ||
      (function(){
        var tc = document.getElementById("toast-container");
        if (!tc) return null;
        var kids = Array.prototype.slice.call(tc.children || []);
        kids = kids.filter(function(k){ return k && k.getBoundingClientRect && k.offsetParent !== null; });
        return kids.length ? kids[kids.length - 1] : null;
      })();

    if (anchor && anchor.getBoundingClientRect) {
      var r = anchor.getBoundingClientRect();
      var top = Math.round(r.bottom + 10);
      box.style.top = top + "px";
    } else {
      box.style.top = "calc(var(--afbHeaderH, 78px) + 96px)";
    }
  }

  function burstConfettiPremium(pieceCount){
    if (!ENABLE_GIFT_CONFETTI) return;
    var box = document.getElementById("afbFunkoMinBox");
    if (!box) return;

    try{
      var old = box.querySelector(".afb-confetti");
      if (old) old.remove();
    }catch(e){}

    try{
      var layer = document.createElement("div");
      layer.className = "afb-confetti";
      box.appendChild(layer);

      var n = pieceCount || 30;
      for (var i=0;i<n;i++){
        var p = document.createElement("i");
        p.className = "afb-confetti-piece";

        var left = Math.random() * 100;
        var hue  = Math.floor(25 + Math.random()*70);
        var w = 6 + Math.random()*6;
        var h = 10 + Math.random()*12;

        p.style.left = left + "%";
        p.style.width = w + "px";
        p.style.height = h + "px";
        p.style.background = "hsl(" + hue + " 95% 58%)";
        p.style.filter = "saturate(1.1)";

        p.style.setProperty("--x", ((Math.random()*180)-90).toFixed(0) + "px");
        p.style.setProperty("--y", (230 + Math.random()*140).toFixed(0) + "px");
        p.style.setProperty("--r", (420 + Math.random()*820).toFixed(0) + "deg");
        p.style.setProperty("--dur", (1250 + Math.random()*650).toFixed(0) + "ms");

        layer.appendChild(p);
      }

      setTimeout(function(){
        try{ layer.remove(); }catch(e2){}
      }, 2000);
    }catch(e){}
  }

  // =========================
  // UI: apply toast (NO flicker)
  // =========================
function applyToastParts(show, kind, parts, opts){
  opts = opts || {};
  var force = !!opts.force;
  var autoHideMs = Number(opts.autoHideMs || 0);
  var progress = opts.progress || null; // {targetPct, fromPct, durationMs, forceColor, forceGlow, monotonic}
  var showClose = (opts.showClose != null) ? !!opts.showClose : true;

  if (!show){
    clearAutoHide();
    AFB_LAST_SHOWN_KIND = "";
    hideToast();
    return;
  }
  if (isGiftSelectionPage()) {
  clearAutoHide();
  hideToast();
  return;
}
  if (!force && AFB_TOAST_CLOSED && TOAST_RESPECT_CLOSE_UNTIL_CART_CHANGE) return;

  var box = ensureToastBox();
  box.classList.remove("is-hidden");
  box.style.display = "";

  var oldKind = String(box.dataset.kind || "");
  kind = String(kind || "");

  if (oldKind !== kind){
    try{ box.dataset.kind = kind; }catch(e){}
    ensureProgressReset();
  } else {
    try{ box.dataset.kind = kind; }catch(e){}
  }

  // ===============================
  // ATUALIZA CONTEÚDO (sem re-render)
  // ===============================
  var titleEl = box.querySelector(".afb-funko-title");
  var mainEl  = box.querySelector(".afb-funko-main");
  var actEl   = box.querySelector(".afb-funko-actions");
  var tipEl   = box.querySelector(".afb-funko-tip");
  var lblEl   = box.querySelector(".afb-funko-counterLabel");

  var newTitle = parts && parts.title ? String(parts.title) : "";
  if (titleEl && titleEl.textContent !== newTitle) titleEl.textContent = newTitle;

  var newMain = parts && parts.main ? String(parts.main) : "";
  if (mainEl && mainEl.innerHTML !== newMain) mainEl.innerHTML = newMain;

  var newActions = parts && parts.actions ? String(parts.actions) : "";
  if (actEl && actEl.innerHTML !== newActions) actEl.innerHTML = newActions;

  var newTip = parts && parts.tip ? String(parts.tip) : "";
  if (tipEl && tipEl.innerHTML !== newTip) tipEl.innerHTML = newTip;

  var newLbl = parts && parts.counterLabel ? String(parts.counterLabel) : "";
  if (lblEl){
    if (lblEl.innerHTML !== newLbl) lblEl.innerHTML = newLbl;
    lblEl.style.display = newLbl ? "" : "none";
  }

  // ===============================
  // BOTÃO FECHAR (X)
  // ===============================
  var closeBtn = box.querySelector(".afb-funko-close");
  if (closeBtn){
    closeBtn.style.display = showClose ? "" : "none";
    closeBtn.onclick = function(){
      AFB_TOAST_CLOSED = true;
      markToastClosedForFp(AFB_LAST_CART_FINGERPRINT || "");

      // cancela buy now se ativo
      if (AFB_BUYNOW_ACTIVE) {
        AFB_BUYNOW_ACTIVE = false;
        if (AFB_BUYNOW_T) { clearTimeout(AFB_BUYNOW_T); AFB_BUYNOW_T = null; }
        try{ window.__AFB_BUYNOW_ADD_PROMISE = null; }catch(_){}
        requestRecheck(0);
      }

      clearAutoHide();
      hideToast();
      AFB_LAST_SHOWN_KIND = "";
    };
  }

  // ===============================
  // INFO PULSE
  // ===============================
  var icBtn = box.querySelector(".afb-funko-icbtn");
  if (icBtn){
    icBtn.onclick = function(ev){
      try{ ev.preventDefault(); ev.stopPropagation(); }catch(e){}
      box.classList.add("afb-info-pulse");
      setTimeout(function(){ box.classList.remove("afb-info-pulse"); }, 420);
    };
  }

  // ===============================
  // IR PARA O CHECKOUT
  // ===============================
  var nowBtn = box.querySelector('[data-afb-checkout-now="1"]');
  if (nowBtn) {
    nowBtn.onclick = function(e){
      try{ e.preventDefault(); }catch(_){}
      cancelBuyNowFlow(); // 👈 cancela contador/timeout

      var href = nowBtn.getAttribute("href") || "/checkout";
      var p = window.__AFB_BUYNOW_ADD_PROMISE;

      if (p && typeof p.then === "function") {
        var done = false;
        var t = setTimeout(function(){
          if (done) return;
          done = true;
          window.__AFB_BUYNOW_ADD_PROMISE = null;
          window.location.href = href;
        }, 2500);

        p.then(function(){}, function(){})
         .then(function(){
           if (done) return;
           done = true;
           clearTimeout(t);
           window.__AFB_BUYNOW_ADD_PROMISE = null;
           window.location.href = href;
         });
        return;
      }

      window.location.href = href;
    };
  }

  // ===============================
  // UX — CONTROLE DE DECISÃO (NOVO)
  // ===============================

  // Escolher brinde → cancela auto-redirect
  var chooseBtn = box.querySelector('[data-afb-choose-gift="1"]');
  if (chooseBtn) {
    chooseBtn.onclick = function(){
      cancelBuyNowFlow();
      AFB_TOAST_CLOSED = true;
      markToastClosedForFp(AFB_LAST_CART_FINGERPRINT || "");
      clearAutoHide();
      hideToast();
    };
  }

  // Continuar comprando → cancela auto-redirect
  var contBtn = box.querySelector('[data-afb-continue-shopping="1"]');
  if (contBtn) {
    contBtn.onclick = function(e){
      try{ e.preventDefault(); }catch(_){}
      cancelBuyNowFlow();
      AFB_TOAST_CLOSED = true;
      markToastClosedForFp(AFB_LAST_CART_FINGERPRINT || "");
      clearAutoHide();
      hideToast();
    };
  }

  // Buy Now ativo → inicia contador visual (15s)
  if (AFB_BUYNOW_ACTIVE && box.querySelector("[data-afb-countdown-num]")) {
    startBuyNowCountdown(Math.max(1, Math.round(BUYNOW_PROGRESS_MS / 1000)));
  }

  // Brinde máximo → anima stepper (escadinha)
  playMaxTierLadder(box);

  // ===============================
  // POSIÇÃO
  // ===============================
  syncToastTop();
  setTimeout(syncToastTop, 60);
  setTimeout(syncToastTop, 220);

  // ===============================
  // PROGRESS BAR
  // ===============================
  if (progress && typeof progress.targetPct === "number"){
    animateProgress(kind, progress.targetPct, progress);
  }

  // ===============================
  // AUTOHIDE
  // ===============================
  clearAutoHide();
  if (autoHideMs > 0){
    AFB_AUTOHIDE_TIMER = setTimeout(function(){
      var b = document.getElementById("afbFunkoMinBox");
      if (b && String(b.dataset.kind || "") === String(kind)) {
        hideToast();
        AFB_LAST_SHOWN_KIND = "";
      }
    }, autoHideMs);
  }

  AFB_LAST_SHOWN_KIND = kind;
}

  // =========================
  // GIFT STEPPER (premium)
  // =========================
  function buildGiftStepper(activeKey, opts){
  opts = opts || {};
  var ladder = !!opts.ladder;

  var steps = [
    { key:"low", label:"Chaveiro" },
    { key:"10",  label:"Panini + Chaveiro" },
    { key:"15",  label:"PopChain" },
    { key:"2k",  label:"Funko Pop" }
  ];
  var idx = 0;
  for (var i=0;i<steps.length;i++){
    if (String(steps[i].key) === String(activeKey)){ idx = i; break; }
  }

  var html = "<div class='afb-gift-stepper' aria-hidden='true'" + (ladder ? " data-afb-tier-ladder='1'" : "") + ">";
  for (var j=0;j<steps.length;j++){
    var cls = "";
    if (j < idx) cls = " is-done";
    if (j === idx) cls = " is-active";
    html += "<div class='afb-gift-step" + cls + "'>"
         +  "<span class='afb-gift-dot'></span>"
         +  "<span>" + escapeHtml(steps[j].label) + "</span>"
         + "</div>";
  }
  html += "</div>";
  return html;
}


  // =========================
  // FUNKO parts
  // =========================
  function getFranchiseHref(){
    var el =
      document.querySelector(".afb-item.afb-item--franchise") ||
      document.querySelector(".afb-item--franchise") ||
      null;

    if (!el) return "";

    if (el.tagName && el.tagName.toLowerCase() === "a" && el.getAttribute("href")) {
      return el.getAttribute("href");
    }

    var a = el.querySelector && el.querySelector("a[href]");
    if (a && a.getAttribute("href")) return a.getAttribute("href");

    var dh = el.getAttribute && (el.getAttribute("data-href") || el.getAttribute("data-url"));
    if (dh) return dh;

    return "";
  }

  function buildFunkoParts(state){
    var missing = Math.max(0, Number(state.missing || 0));
    var isOk = missing <= 0;

    var pct = Math.min(100, Math.round(((state.funkoQty || 0) / MIN_FUNKO_QTY) * 100));
    var title = isOk ? "Mínimo atingido! 🎉" : "Quase lá! 🚀";

    var main =
      (MODE === "only_funko"
        ? "Para finalizar um pedido só com <strong>Funko Pop</strong>, você precisa de <strong>" + MIN_FUNKO_QTY + " unidades</strong> <span class='afb-funko-sub'>(pode misturar modelos)</span>."
        : "Você tem <strong>Funko Pop</strong> no carrinho. O mínimo é <strong>" + MIN_FUNKO_QTY + "</strong> unidades."
      );

    if (isOk) {
      main = "Perfeito — você completou <strong>" + MIN_FUNKO_QTY + " Funko Pops</strong>. Checkout liberado ✅";
    }

    var counterLabel = isOk
      ? "<span class='afb-funko-missing ok'>Liberado ✅</span>"
      : "<span class='afb-funko-missing'>Faltam <strong>" + missing + "</strong> " + plural(missing,"Funko Pop","Funko Pops") + "</span>";

    var actions;
    if (isOk) {
      actions = "<a class='afb-funko-btn' href='/checkout'>Finalizar compra</a>";
    } else {
      var hrefFranchise = getFranchiseHref();
      actions =
        "<a class='afb-funko-btn' href='/collections/funko' target='_blank' rel='noopener'>Escolher mais Funko Pops</a>" +
        (hrefFranchise
          ? "<a class='afb-funko-btn afb-funko-btn--alt' href='" + escapeHtml(hrefFranchise) + "' target='_blank' rel='noopener'>Adicionar outro do tema</a>"
          : ""
        );
    }

    var tip = isOk
      ? "✅ Agora você pode finalizar normalmente."
      : "💡 Dica: continue adicionando Funko até completar o mínimo.";

    return { title:title, main:main, actions:actions, tip:tip, pct:pct, counterLabel:counterLabel };
  }

  // =========================
  // GIFT parts
  // =========================
  function giftTitleForTier(tier){
  var k = String((tier && tier.key) || "");
  if (k === "low") return "Brinde desbloqueado 🎁";
  if (k === "10")  return "Upgrade de brinde desbloqueado 🎁";
  if (k === "15")  return "PopChain desbloqueado 🎉";
  if (k === "2k")  return "Nível máximo desbloqueado: Funko Pop 🏆";
  return "Brinde desbloqueado 🎁";
}

function buildGiftPartsByTier(tier, opts){
  opts = opts || {};
  var buyNow  = !!opts.buyNow;
  var compact = !!opts.compact; // ✅ modo intermediário (menos caos)

  var baseCents      = Math.max(0, Number(opts.baseCents || 0));
  var eligibleCents  = Math.max(0, Number(opts.eligibleCents || baseCents));
  var cartTotalCents = Math.max(0, Number(opts.cartTotalCents || 0));

  var topupPossible = !!opts.topupPossible;
  var topupGapCents = Math.max(0, Number(opts.topupGapCents || 0));
  var topupUsedCents= Math.max(0, Number(opts.topupUsedCents || 0));

  var nextT = opts.nextTier || null;

  var key = String((tier && tier.key) || "");
  var hasCTA = (key === "15" || key === "2k");

  var couponCode = hasCTA ? String(tier.couponCode || "") : "";
  var ctaText  = (key === "15") ? "Escolher meu PopChain" : "Escolher meu Funko Pop";
  var ctaHref  = (hasCTA && tier.choosePath && couponCode) ? discountLink(couponCode, tier.choosePath) : "";

  // ✅ stepper com “ladder” no tier máximo (efeito escadinha acontece no applyToastParts)
  var stepper = buildGiftStepper(key, { ladder: (String(key) === "2k") });

  // =========================
  // COMPACT (quando sobe tier)
  // =========================
  if (compact) {
    var compactMain =
      stepper +
      "<div style='margin-top:6px;font-weight:900'>🎁 Novo brinde desbloqueado:</div>" +
      "<div style='margin-top:6px;opacity:.92'><strong>" + escapeHtml(tier.giftLabel) + "</strong></div>" +
      "<div class='afb-funko-subline' style='margin-top:8px;opacity:.85'>Atualizando benefícios…</div>";

    return {
      title: giftTitleForTier(tier),
      main: compactMain,
      actions: "",
      tip: "",
      pct: 100,
      couponCode: couponCode,
      counterLabel: ""
    };
  }

  // =========================
  // FULL (detalhado)
  // =========================
  var pct = 100;
  var nextLine = "";

  if (nextT && Number(nextT.minCents || 0) > 0) {
    var need = Math.max(0, Number(nextT.minCents) - eligibleCents);
    pct = Math.min(100, Math.round((eligibleCents / Number(nextT.minCents)) * 100));
    nextLine =
      "<div class='afb-funko-subline'>Próximo brinde: <strong>" + escapeHtml(nextT.giftLabel) + "</strong> — faltam <strong>" + moneyBRL(need) + "</strong>.</div>";
  } else {
    pct = 100;
    nextLine = "<div class='afb-funko-subline'>Você já está no maior brinde. 👑</div>";
  }

  var totalsLine =
    "<div class='afb-funko-subline'>Total elegível (sem Funko): <strong>" + moneyBRL(baseCents) + "</strong>.</div>" +
    (cartTotalCents && cartTotalCents !== baseCents
      ? "<div class='afb-funko-subline'>Subtotal do carrinho: <strong>" + moneyBRL(cartTotalCents) + "</strong>.</div>"
      : ""
    );

  // ✅ texto didático pro “inteirar com Funko”
  var topupLine = "";
  if (topupUsedCents > 0) {
    topupLine =
      "<div class='afb-funko-subline' style='color:#ffd36a;font-weight:900'>✅ Funko ajudou a completar: <strong>+" + moneyBRL(topupUsedCents) + "</strong>.</div>";
  } else if (topupPossible && topupGapCents > 0) {
    topupLine =
      "<div class='afb-funko-subline' style='color:#ffd36a;font-weight:900'>" +
        "⚡ Falta apenas <strong>" + moneyBRL(topupGapCents) + "</strong> para liberar o próximo brinde. " +
        "Se quiser, você pode completar essa diferença com itens Funko: " +
        "até <strong>" + moneyBRL(TOPUP_CLOSE_GAP_MAX_CENTS) + "</strong> em Funko conta <span style='opacity:.9'>(somente para fechar o valor que falta)</span>." +
      "</div>";
  }

  var yellowMsg =
    "<div style='margin-top:10px;padding:10px 12px;border-radius:14px;" +
      "background:rgba(255,204,0,.10);border:1px solid rgba(255,204,0,.38);" +
      "color:#ffd36a;font-weight:900;letter-spacing:.2px'>" +
      "🎁 <span style='opacity:.9'>Brinde atual:</span> <strong>" + escapeHtml(tier.giftLabel) + "</strong> ✅" +
    "</div>";

  var couponLine = (couponCode)
    ? "<div class='afb-funko-subline' style='margin-top:8px'>Cupom liberado: <strong>" + escapeHtml(couponCode) + "</strong> ✅ <span style='opacity:.9'>(aplicado automaticamente)</span></div>"
    : "";

  // ✅ contador real (15s se você colocou BUYNOW_PROGRESS_MS=15000)
  var sec = Math.max(1, Math.round(BUYNOW_PROGRESS_MS / 1000));
  var buyNowLine = buyNow
    ? "<div class='afb-funko-subline afb-buynowline' style='margin-top:8px;opacity:.92'>" +
        "⏳ Auto-redirecionamento em <strong><span data-afb-countdown-num>" + sec + "</span>s</strong>. " +
        "Escolha abaixo o que você prefere fazer." +
      "</div>"
    : "";

  var main =
    stepper +
    totalsLine +
    topupLine +
    nextLine +
    couponLine +
    buyNowLine;

  // =========================
  // BOTÕES (checkout / continuar / escolher brinde)
  // =========================
  var checkoutHref = couponCode
    ? ("/discount/" + encodeURIComponent(couponCode) + "?redirect=/checkout")
    : "/checkout";

  var btnCheckout =
    "<a class='afb-funko-btn afb-funko-btn--alt' href='" + escapeHtml(checkoutHref) + "' data-afb-checkout-now='1'>" +
      "Ir para o checkout" +
    "</a>";

  var btnContinue =
    "<button type='button' class='afb-funko-btn afb-funko-btn--ghost' data-afb-continue-shopping='1'>" +
      "Continuar comprando" +
    "</button>";

  var btnChoose = (hasCTA && ctaHref)
    ? "<a class='afb-funko-btn' href='" + escapeHtml(ctaHref) + "' target='_blank' rel='noopener' data-afb-choose-gift='1'>" +
        escapeHtml(ctaText) +
      "</a>"
    : "";

  // ações:
  // - sempre mostra o brinde atual (yellow)
  // - se buyNow: sempre dá opções (checkout + continuar) e, se tiver, escolher brinde
  // - se não buyNow, só mostra botões quando tiver brinde selecionável (hasCTA)
  var actions = yellowMsg;

  if (buyNow || hasCTA) {
    actions =
      yellowMsg +
      "<div class='afb-funko-actions' style='display:flex;gap:10px;flex-wrap:wrap;margin-top:12px'>" +
        (btnChoose ? (btnChoose) : "") +
        btnCheckout +
        btnContinue +
      "</div>";
  }

  // =========================
  // TIP (upsell)
  // =========================
  var tip;
  if (hasCTA) {
    tip = buyNow
      ? "✨ Dica rápida: escolha seu brinde em outra aba, adicione ao carrinho e finalize quando estiver pronto."
      : "💡 Escolha seu brinde, adicione ao carrinho e finalize normalmente.";
  } else {
    tip = buyNow
      ? "💡 Quer subir de brinde? Clique em “Continuar comprando” e complete o valor que falta."
      : "💡 Dica: aumentando o total, você desbloqueia brindes melhores.";
  }

  return {
    title: giftTitleForTier(tier),
    main: main,
    actions: actions,
    tip: tip,
    pct: pct,
    couponCode: couponCode,
    counterLabel: ""
  };
}

  // =========================
  // STATE compute
  // =========================
  function computeState(cart) {
    var funkoQty = 0;
    var nonFunkoQty = 0;
    var nonFunkoTotalCents = 0;

    var cartTotalCents = Number(cart.total_price || 0);

    (cart.items || []).forEach(function (it) {
      var q = Number(it.quantity || 0);
      var line = (it.final_line_price != null)
        ? Number(it.final_line_price)
        : (Number(it.final_price || it.price || 0) * q);

      if (isFunkoItem(it)) funkoQty += q;
      else {
        nonFunkoQty += q;
        nonFunkoTotalCents += line;
      }
    });

    var hasFunko = funkoQty > 0;

    var funkoRuleApplies = false;
    if (hasFunko) {
      if (MODE === "only_funko") funkoRuleApplies = (nonFunkoQty === 0);
      else funkoRuleApplies = true;
    }

    var shouldBlock = false;
    var missing = 0;

    if (funkoRuleApplies) {
      shouldBlock = (funkoQty < MIN_FUNKO_QTY);
      missing = Math.max(0, MIN_FUNKO_QTY - funkoQty);
    }

    var elig = computeGiftEligibility(nonFunkoTotalCents, cartTotalCents);

    var giftTier = null;
    if (ENABLE_GIFT_TOAST && nonFunkoTotalCents > 0 && !shouldBlock) {
      giftTier = pickGiftTier(elig.eligibleCents);
    }

    return {
      shouldBlock: shouldBlock,
      funkoQty: funkoQty,
      nonFunkoQty: nonFunkoQty,
      missing: missing,
      hasFunko: hasFunko,
      funkoRuleApplies: funkoRuleApplies,
      giftTier: giftTier,

      nonFunkoTotalCents: nonFunkoTotalCents,

      cartTotalCents: elig.cartTotalCents,
      funkoTotalCents: elig.funkoTotalCents,
      eligibleCents: elig.eligibleCents,
      topupUsedCents: elig.topupUsedCents,
      topupGapCents: elig.topupGapCents,
      topupPossible: elig.topupPossible
    };
  }

  // =========================
  // Gift buy now flow (quando já está no carrinho)
  // =========================
  function startGiftBuyNowFromState(state, fp){
    if (!state || !state.giftTier) {
      var code0 = getDiscountCodeForTotal(state ? state.eligibleCents : 0);
      return gotoCheckoutWithDiscount(code0);
    }

    if (AFB_BUYNOW_T) { clearTimeout(AFB_BUYNOW_T); AFB_BUYNOW_T = null; }
    AFB_BUYNOW_ACTIVE = true;

    var nextT = nextGiftTier(state.eligibleCents);
    var tier = state.giftTier;

    var parts = buildGiftPartsByTier(tier, {
      buyNow: true,
      baseCents: state.nonFunkoTotalCents,
      eligibleCents: state.eligibleCents,
      cartTotalCents: state.cartTotalCents,
      topupUsedCents: state.topupUsedCents,
      topupGapCents: state.topupGapCents,
      topupPossible: state.topupPossible,
      nextTier: nextT,
      compact: false
    });

    if (parts && parts.couponCode) autoApplyDiscountInBackground(parts.couponCode, fp || "buynow");

    var celebrate = (String(tier.key) === "15" || String(tier.key) === "2k");

    applyToastParts(true, "buynow_elected", parts, {
      showClose: true,
      force: true,
      autoHideMs: 0,
      progress: {
        targetPct: 100,
        fromPct: 0,
        durationMs: BUYNOW_PROGRESS_MS,
        forceColor: celebrate ? "rgba(255,214,0,.98)" : null,
        forceGlow: !!celebrate,
        monotonic: true
      }
    });

    if (celebrate) setTimeout(function(){ burstConfettiPremium(30); }, 420);

    var discountCode = getDiscountCodeForTotal(state.eligibleCents);

    AFB_BUYNOW_T = setTimeout(function(){
      gotoCheckoutWithDiscount(discountCode);
    }, BUYNOW_PROGRESS_MS);
  }

  // =========================
  // GIFT: anima “escadinha” quando pula tiers (premium)
  // - passos intermediários compactos (sem caos)
  // - final detalhado + confete
  // =========================
  function getGiftTiersSortedAsc(){
    return GIFT_TIERS.slice().sort(function(a,b){ return a.minCents - b.minCents; });
  }

  function idxByKey(arr, key){
    for (var i=0;i<arr.length;i++){
      if (String(arr[i].key) === String(key)) return i;
    }
    return -1;
  }

  function animateGiftTierLadder(prevEligible, newEligible, endTier, fp, finalState){
    finalState = finalState || {};
    var tiersAsc = getGiftTiersSortedAsc();

    var prevTier = pickGiftTier(prevEligible || 0);
    var prevIdx = idxByKey(tiersAsc, prevTier ? prevTier.key : "low");
    var endIdx  = idxByKey(tiersAsc, endTier ? endTier.key : "low");

    var idx10 = idxByKey(tiersAsc, "10");

    // evita animar "low" pra "10" quando o usuário já tá no 10+
    var startIdx = prevIdx;
    if (endIdx >= idx10 && startIdx < idx10) startIdx = idx10;

    if (!(endIdx > startIdx)) return false;

    var animId = ++window.__AFB_GIFT_ANIM_ID;

    var stepHold = 920; // ✅ mais “premium”/entendível
    var stepBar  = 680;

    function step(i){
      if (window.__AFB_GIFT_ANIM_ID !== animId) return;

      var tier = tiersAsc[i];
      var isLast = (i === endIdx);

      var eligibleForStep = isLast ? newEligible : Number(tier.minCents || 0);
      var nextT = (i < tiersAsc.length - 1) ? tiersAsc[i+1] : null;

      var parts = buildGiftPartsByTier(tier, {
        buyNow: false,
        compact: !isLast, // ✅ passos intermediários compactos
        baseCents: finalState.nonFunkoTotalCents,
        eligibleCents: eligibleForStep,
        cartTotalCents: finalState.cartTotalCents,
        topupUsedCents: isLast ? finalState.topupUsedCents : 0,
        topupGapCents: isLast ? finalState.topupGapCents : 0,
        topupPossible: isLast ? finalState.topupPossible : false,
        nextTier: nextT
      });

      if (parts && parts.couponCode) autoApplyDiscountInBackground(parts.couponCode, fp);

      var isCelebration = isLast && (String(tier.key) === "15" || String(tier.key) === "2k");

      applyToastParts(true, "gift_ladder", parts, {
        showClose: true,
        force: true,
        autoHideMs: 0,
        progress: {
          targetPct: 100,
          fromPct: 0,
          durationMs: isLast ? 820 : stepBar,
          forceColor: isCelebration ? "rgba(255,214,0,.98)" : null,
          forceGlow: !!isCelebration,
          monotonic: false
        }
      });

      if (isLast) {
        if (isCelebration) setTimeout(function(){ burstConfettiPremium(34); }, 420);

        // segura final um pouco p/ pessoa entender
        clearAutoHide();
        AFB_AUTOHIDE_TIMER = setTimeout(function(){
          // só some se ainda é o ladder
          var b = document.getElementById("afbFunkoMinBox");
          if (b && String(b.dataset.kind||"") === "gift_ladder") hideToast();
        }, (isCelebration ? 16000 : 12000));

        return;
      }

      setTimeout(function(){
        ensureProgressReset();
        step(i+1);
      }, stepHold);
    }

    step(startIdx);
    return true;
  }

  // =========================
  // RECHECK
  // =========================
  function requestRecheck(delayMs){
    if (AFB_BUYNOW_ACTIVE) return;
    if (AFB_RECHECK_TIMER) clearTimeout(AFB_RECHECK_TIMER);
    AFB_RECHECK_TIMER = setTimeout(function(){
      runRecheck();
    }, (typeof delayMs === "number" ? delayMs : 180));
  }

  function runRecheck(){
    if (AFB_BUYNOW_ACTIVE) return Promise.resolve(window.__AFB_FUNKO_LAST_STATE || {});
    AFB_RECHECK_CHAIN = AFB_RECHECK_CHAIN
      .catch(function(){})
      .then(function(){ return recheckCore(); });
    return AFB_RECHECK_CHAIN;
  }

  window.afbFunkoRecheck = requestRecheck;
  window.AFB_FUNKO_MIN = window.AFB_FUNKO_MIN || {};
  window.AFB_FUNKO_MIN.recheck = runRecheck;

  function recheckCore() {
    var prevState = window.__AFB_FUNKO_LAST_STATE || null;

    return fetchCart()
      .then(function (cart) {
        var fp = cartFingerprint(cart);

        AFB_TOAST_CLOSED = isToastClosedForFp(fp);

        var cartChanged = (fp !== AFB_LAST_CART_FINGERPRINT);
        if (cartChanged) {
          AFB_LAST_CART_FINGERPRINT = fp;
          AFB_TOAST_CLOSED = false;
          markToastClosedForFp("");
        }

        var state = computeState(cart);
        window.__AFB_FUNKO_LAST_STATE = state;

        applyCheckout(!!state.shouldBlock);

        if (cartChanged) dispatchCartSignals(cart);

        // ✅ mais folga (tema às vezes demora pra atualizar o cart.js)
        var justAdded = (Date.now() - AFB_LAST_CART_ADD_TS) < 6500;

        // FUNKO TOAST na hora certa
        if (state.funkoRuleApplies && (cartChanged && justAdded)) {
          var partsF = buildFunkoParts(state);

          applyToastParts(true, (state.missing<=0 ? "funko_ok" : "funko_min"), partsF, {
            showClose: true,
            force: false,
            autoHideMs: FUNKO_ATC_AUTOHIDE_MS,
            progress: { targetPct: partsF.pct, fromPct: 0, durationMs: 560, monotonic: true }
          });

          return state;
        }

        if (PASSIVE_BLOCK_TOAST && state.funkoRuleApplies && state.shouldBlock && !AFB_TOAST_CLOSED) {
          var partsP = buildFunkoParts(state);
          applyToastParts(true, "funko_min_passive", partsP, {
            showClose: true,
            force: false,
            autoHideMs: 0,
            progress: { targetPct: partsP.pct, fromPct: 0, durationMs: 560, monotonic: true }
          });
          return state;
        }

        // Gift toast (só quando carrinho muda) — e não compete com Funko
        if (!state.funkoRuleApplies && state.giftTier) {
          var kindGift = "gift_" + state.giftTier.key;

          if (!GIFT_TOAST_ONLY_ON_CART_CHANGE || cartChanged) {
            if (!wasGiftShown(fp, kindGift)) {

              var prevEligible = prevState ? Number(prevState.eligibleCents || 0) : 0;
              var newEligible  = Number(state.eligibleCents || 0);

              var didAnimate = animateGiftTierLadder(prevEligible, newEligible, state.giftTier, fp, state);

              if (!didAnimate) {
                var nextT = nextGiftTier(state.eligibleCents);

                var partsGift = buildGiftPartsByTier(state.giftTier, {
                  buyNow: false,
                  compact: false,
                  baseCents: state.nonFunkoTotalCents,
                  eligibleCents: state.eligibleCents,
                  cartTotalCents: state.cartTotalCents,
                  topupUsedCents: state.topupUsedCents,
                  topupGapCents: state.topupGapCents,
                  topupPossible: state.topupPossible,
                  nextTier: nextT
                });

                if (partsGift && partsGift.couponCode) autoApplyDiscountInBackground(partsGift.couponCode, fp);

                var celebrate = (String(state.giftTier.key) === "15" || String(state.giftTier.key) === "2k");

                // 🚫 NÃO MOSTRA TOAST DE UPSELL NA PÁGINA DE ESCOLHA DO BRINDE
if (!isGiftSelectionPage()) {

  applyToastParts(true, kindGift, partsGift, {
    showClose: true,
    force: false,
    autoHideMs: celebrate ? 0 : 12000,
    progress: {
      targetPct: celebrate ? 100 : partsGift.pct,
      fromPct: 0,
      durationMs: celebrate ? 820 : 720,
      forceColor: celebrate ? "rgba(255,214,0,.98)" : null,
      forceGlow: !!celebrate,
      monotonic: false
    }
  });

}


                if (celebrate) setTimeout(function(){ burstConfettiPremium(32); }, 420);
              }

              markGiftShown(fp, kindGift);
              return state;
            }
          }
        }

        if (!state.funkoRuleApplies && !state.giftTier) {
          applyToastParts(false, "", null, {});
        }

        return state;
      })
      .catch(function () {
        applyCheckout(false);
        applyToastParts(false, "", null, {});
        return { shouldBlock:false };
      });
  }

  // =========================
  // HOOK: cart changes (fetch + XHR)
  // =========================
  (function hookCartNetwork(){
    if (window.__AFB_CART_HOOKED) return;
    window.__AFB_CART_HOOKED = true;

    // fetch
    try{
      var _fetch = window.fetch;
      if (typeof _fetch === "function") {
        window.fetch = function(){
          var url = "";
          try{
            url = (typeof arguments[0] === "string") ? arguments[0] : (arguments[0] && arguments[0].url) || "";
          }catch(e){}
          return _fetch.apply(this, arguments).then(function(res){
            try{
              if (/\/cart\/add(?:\.js)?/i.test(url)) AFB_LAST_CART_ADD_TS = Date.now();
              if (/\/cart\/(add|change|update|clear)(?:\.js)?/i.test(url)) {
                setTimeout(function(){ requestRecheck(0); }, 120);
              }
            }catch(e2){}
            return res;
          });
        };
      }
    }catch(e){}

    // XHR
    try{
      var _open = XMLHttpRequest.prototype.open;
      var _send = XMLHttpRequest.prototype.send;

      XMLHttpRequest.prototype.open = function(method, url){
        this.__afbUrl = url;
        return _open.apply(this, arguments);
      };

      XMLHttpRequest.prototype.send = function(){
        var xhr = this;

        function done(){
          try{
            var u = String(xhr.__afbUrl || "");
            if (/\/cart\/add(?:\.js)?/i.test(u)) AFB_LAST_CART_ADD_TS = Date.now();
            if (/\/cart\/(add|change|update|clear)(?:\.js)?/i.test(u)) {
              setTimeout(function(){ requestRecheck(0); }, 140);
            }
          }catch(e3){}
        }

        xhr.addEventListener("load", done);
        xhr.addEventListener("error", done);
        xhr.addEventListener("abort", done);

        return _send.apply(this, arguments);
      };
    }catch(e){}
  })();

  // =========================
  // EVENTS
  // =========================
  window.addEventListener("resize", function(){ syncToastTop(); }, { passive:true });

  document.addEventListener("click", function(ev){
    var atc = ev.target && ev.target.closest ? ev.target.closest(ADD_TO_CART_SELECTORS) : null;
    if (!atc) return;

    AFB_LAST_CART_ADD_TS = Date.now();
    requestRecheck(260);
  }, true);

  document.addEventListener("submit", function(ev){
    var form = ev.target;
    if (!form) return;
    var act = String(form.action || "");
    if (!/\/cart\/add/i.test(act) && !(form.matches && form.matches('form[action^="/cart/add"]'))) return;

    AFB_LAST_CART_ADD_TS = Date.now();
    requestRecheck(260);
  }, true);

  // ✅ Checkout click — só bloqueia se precisar
  document.addEventListener("click", function (ev) {
    var target = ev.target && ev.target.closest ? ev.target.closest(CHECKOUT_SELECTORS) : null;
    if (!target) return;
    if ((target.tagName || "").toLowerCase() === "form") return;

    var st = window.__AFB_FUNKO_LAST_STATE;

    if (st && st.shouldBlock) {
      ev.preventDefault();
      ev.stopImmediatePropagation();

      var parts = buildFunkoParts(st);
      applyToastParts(true, "funko_min_force", parts, {
        showClose: true,
        force: true,
        autoHideMs: 0,
        progress: { targetPct: parts.pct, fromPct: 0, durationMs: 560, monotonic: true }
      });
      return;
    }

    requestRecheck(50);
  }, true);

  // BUY NOW
  document.addEventListener("click", function(ev){
    var btn = ev.target && ev.target.closest ? ev.target.closest(BUY_NOW_SELECTORS) : null;
    if (!btn) return;

    if (!isLikelyProductPage()) return;

    // bloqueia fluxo nativo imediatamente
    ev.preventDefault();
    ev.stopImmediatePropagation();

    var isFunkoPage = isFunkoProductPage();

    // =========================
    // FUNKO BuyNow
    // =========================
    if (isFunkoPage) {
      if (AFB_FUNKO_BUY_LOCK) return;
      AFB_FUNKO_BUY_LOCK = true;
      setTimeout(function(){ AFB_FUNKO_BUY_LOCK = false; }, 1600);

      var qty = getProductQty();
      var variantId = getCurrentVariantId();

      fetchCart().then(function(cart0){
        var prevFp = cartFingerprint(cart0 || {});
        AFB_LAST_CART_ADD_TS = Date.now();

        return triggerNativeAddToCart(qty).then(function(){
          return waitCartChangesFromFp(prevFp, 2200).then(function(res){
            if (res && res.changed) return res.cart;

            if (variantId) {
              return addToCartByVariant(variantId, qty)
                .then(function(){ return fetchCart(); })
                .catch(function(){ return fetchCart(); });
            }

            return fetchCart();
          });
        });
      }).then(function(cartAfter){
        dispatchCartSignals(cartAfter || null);

        return runRecheck().then(function(state){
          state = state || {};

          // ✅ SE NÃO APLICA REGRA FUNKO (carrinho misto), MOSTRA BRINDE + 7s
          if (!state.funkoRuleApplies) {
            return startGiftBuyNowFromState(state, AFB_LAST_CART_FINGERPRINT || "buynow");
          }

          // ✅ regra Funko vale: bloqueia ou libera
          if (state.shouldBlock) {
            var parts = buildFunkoParts(state);
            applyToastParts(true, "funko_min_force", parts, {
              showClose: true,
              force: true,
              autoHideMs: 0,
              progress: { targetPct: parts.pct, fromPct: 0, durationMs: 560, monotonic: true }
            });
            return;
          }

          var okParts = buildFunkoParts(state);
          applyToastParts(true, "funko_ok_force", okParts, {
            showClose: true,
            force: true,
            autoHideMs: 4500,
            progress: { targetPct: 100, fromPct: 0, durationMs: 560, monotonic: true }
          });

          setTimeout(function(){
            gotoCheckoutWithDiscount("");
          }, FUNKO_BUYNOW_CONFIRM_MS);
        });
      }).catch(function(){
        runRecheck().then(function(state){
          state = state || {};
          var parts = buildFunkoParts(state);
          applyToastParts(true, "funko_min_force", parts, {
            showClose: true,
            force: true,
            autoHideMs: 0,
            progress: { targetPct: parts.pct || 0, fromPct: 0, durationMs: 560, monotonic: true }
          });
        });
      });

      return;
    }

    // =========================
    // NÃO-FUNKO BuyNow
    // =========================
    if (AFB_BUYNOW_ACTIVE) return;
    AFB_BUYNOW_ACTIVE = true;

    if (AFB_BUYNOW_T) { clearTimeout(AFB_BUYNOW_T); AFB_BUYNOW_T = null; }

    var qty2 = getProductQty();
    var priceCents = getCurrentProductPriceCents();
    var lineCents = Math.max(0, Number(priceCents || 0) * Number(qty2 || 1));

    if (lineCents < BUYNOW_SHOW_ONLY_IF_PRICE_GE_CENTS) {
      AFB_BUYNOW_ACTIVE = false;
      return gotoCheckoutWithDiscount("");
    }

    var variantId2 = getCurrentVariantId();

    fetchCart().then(function(cart0){
      cart0 = cart0 || { items:[], total_price:0 };
      var st0 = computeState(cart0);

      var baseAfter = Number(st0.nonFunkoTotalCents || 0) + lineCents;
      var cartTotalAfter = Number(cart0.total_price || 0) + lineCents;

      var eligAfter = computeGiftEligibility(baseAfter, cartTotalAfter);
      var tier = pickGiftTier(eligAfter.eligibleCents);
      var nextT = nextGiftTier(eligAfter.eligibleCents);

      var partsElected = buildGiftPartsByTier(tier, {
        buyNow: true,
        compact: false,
        baseCents: baseAfter,
        eligibleCents: eligAfter.eligibleCents,
        cartTotalCents: eligAfter.cartTotalCents,
        topupUsedCents: eligAfter.topupUsedCents,
        topupGapCents: eligAfter.topupGapCents,
        topupPossible: eligAfter.topupPossible,
        nextTier: nextT
      });

      if (partsElected && partsElected.couponCode) {
        autoApplyDiscountInBackground(partsElected.couponCode, AFB_LAST_CART_FINGERPRINT || "buynow");
      }

      var celebrate = (String(tier.key) === "15" || String(tier.key) === "2k");

      applyToastParts(true, "buynow_elected", partsElected, {
        showClose: true,
        force: true,
        autoHideMs: 0,
        progress: {
          targetPct: 100,
          fromPct: 0,
          durationMs: BUYNOW_PROGRESS_MS,
          forceColor: celebrate ? "rgba(255,214,0,.98)" : null,
          forceGlow: !!celebrate,
          monotonic: true
        }
      });

      if (celebrate) setTimeout(function(){ burstConfettiPremium(30); }, 420);

      var discountCode = getDiscountCodeForTotal(eligAfter.eligibleCents);

      var addPromise = (variantId2
        ? addToCartByVariant(variantId2, qty2)
        : triggerNativeAddToCart(qty2).then(function(){ return true; })
      );

      window.__AFB_BUYNOW_ADD_PROMISE = addPromise;

      AFB_BUYNOW_T = setTimeout(function () {
        var done = false;

        var force = setTimeout(function () {
          if (done) return;
          done = true;
          window.__AFB_BUYNOW_ADD_PROMISE = null;
          gotoCheckoutWithDiscount(discountCode);
        }, 2500);

        addPromise
          .catch(function(){})
          .finally(function(){
            if (done) return;
            done = true;
            clearTimeout(force);
            window.__AFB_BUYNOW_ADD_PROMISE = null;
            gotoCheckoutWithDiscount(discountCode);
          });
      }, BUYNOW_PROGRESS_MS);

    }).catch(function(){
      AFB_BUYNOW_ACTIVE = false;
      gotoCheckoutWithDiscount("");
    });
  }, true);

  document.addEventListener("DOMContentLoaded", function () {
    runRecheck();
  });

  // ✅ SEM reload: pageshow (bfcache) -> sync leve
  window.addEventListener("pageshow", function(e){
    try{
      if ((e && e.persisted) || (function(){
        try{
          var nav = performance.getEntriesByType && performance.getEntriesByType("navigation");
          if (nav && nav[0] && nav[0].type) return nav[0].type === "back_forward";
        }catch(err){}
        try{
          if (performance && performance.navigation) return performance.navigation.type === 2;
        }catch(err2){}
        return false;
      })()) {
        fetchCart()
          .then(function(c){ dispatchCartSignals(c); })
          .catch(function(){})
          .finally(function(){ requestRecheck(0); });
        return;
      }
    }catch(e3){}
    requestRecheck(0);
  }, true);

  // =========================
  // POLL / RECHECK (leve)
  // =========================
  if (!window.__AFB_POLL_READY) {
    window.__AFB_POLL_READY = true;

    var AFB_LAST_ACTIVE_TS = Date.now();

    window.addEventListener("focus", function(){
      AFB_LAST_ACTIVE_TS = Date.now();
      if (!AFB_BUYNOW_ACTIVE) requestRecheck(150);
    }, true);

    document.addEventListener("visibilitychange", function(){
      if (!document.hidden) {
        AFB_LAST_ACTIVE_TS = Date.now();
        if (!AFB_BUYNOW_ACTIVE) requestRecheck(150);
      }
    }, true);

    setInterval(function(){
      if (AFB_BUYNOW_ACTIVE) return;
      if (document.visibilityState !== "visible") return;

      if (Date.now() - AFB_LAST_ACTIVE_TS > 25000) {
        requestRecheck(0);
      }
    }, 8000);
  }

})();





// PAG CART
/* =========================================================
   AFB CART V3 — AJAX STEPPER + SYNC /cart.js (SÓ /cart)
========================================================= */
(function () {
  if (window.AFB_CART_V3_LOADED) return;
  window.AFB_CART_V3_LOADED = true;

  function isCartPage() {
    if (location.pathname !== "/cart") return false;
    return !!document.getElementById("checkout-cart");
  }
  if (!isCartPage()) return;

  var root = document.getElementById("checkout-cart");
  var form = document.getElementById("cart_form") || root.querySelector('form[action="/cart"]');
  var list = root.querySelector(".afb-cart-list");

  function fmtBRL(cents) {
    var n = (Number(cents) || 0) / 100;
    return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(n);
  }

  function fetchCart() {
    return fetch("/cart.js", { headers: { "Accept": "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r.json(); });
  }

  function changeLine(line, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function setText(el, txt) { if (el) el.textContent = txt; }

  function syncDomWithCart(cart) {
    if (!cart || !list) return;

    var itemEls = list.querySelectorAll(".afb-cart-item");
    if (!itemEls || itemEls.length !== cart.items.length) {
      // se divergir, melhor recarregar pra não quebrar linhas
      location.reload();
      return;
    }

    // header item count
    var subtitle = root.querySelector(".afb-cart-subtitle");
    if (subtitle) subtitle.textContent = cart.item_count + " item(s)";

    // cada item (assumindo mesma ordem)
    for (var i = 0; i < itemEls.length; i++) {
      var el = itemEls[i];
      var line = i + 1;
      var ci = cart.items[i];

      el.dataset.line = String(line);

      // qty input
      var input = el.querySelector(".afb-qty-input");
      if (input) {
        input.dataset.line = String(line);
        input.value = String(ci.quantity);
      }

      // remove href
      var removeA = el.querySelector("a.afb-btn-remove");
      if (removeA) {
        removeA.setAttribute("href", "/cart/change?line=" + line + "&quantity=0");
      }

      // prices
      var priceLines = el.querySelectorAll(".afb-price-line");
      if (priceLines && priceLines.length >= 2) {
        var unitVal = priceLines[0].querySelector(".val");
        var totalVal = priceLines[1].querySelector(".val");
        setText(unitVal, fmtBRL(ci.final_price));
        setText(totalVal, fmtBRL(ci.final_line_price));
      }
    }

    // resumo: Subtotal = soma sem desconto (original_total_price)
    var rows = root.querySelectorAll(".afb-summary-row");
    var subtotalRow = null;
    var discountRow = null;

    for (var r = 0; r < rows.length; r++) {
      var label = rows[r].querySelector("span");
      if (!label) continue;
      var t = (label.textContent || "").toLowerCase();
      if (t.indexOf("subtotal") >= 0) subtotalRow = rows[r];
      if (t.indexOf("desconto") >= 0) discountRow = rows[r];
    }

    if (subtotalRow) {
      setText(subtotalRow.querySelector("strong"), fmtBRL(cart.original_total_price));
    }

    var discount = Number(cart.total_discount) || 0;
    if (discount > 0) {
      if (!discountRow) {
        // cria linha de desconto se não existir
        discountRow = document.createElement("div");
        discountRow.className = "afb-summary-row is-discount";
        discountRow.innerHTML = '<span>Desconto</span><strong></strong>';
        // insere depois do subtotal
        if (subtotalRow && subtotalRow.parentNode) {
          subtotalRow.parentNode.insertBefore(discountRow, subtotalRow.nextSibling);
        }
      }
      setText(discountRow.querySelector("strong"), "- " + fmtBRL(discount));
    } else {
      if (discountRow) discountRow.parentNode.removeChild(discountRow);
    }
  }

  /* ---------- Cupom: persistir e aplicar no checkout ---------- */
  var couponInput = document.getElementById("discount");
  if (couponInput) {
    try {
      var saved = localStorage.getItem("afb_cart_discount") || "";
      if (!couponInput.value && saved) couponInput.value = saved;
      couponInput.addEventListener("input", function () {
        localStorage.setItem("afb_cart_discount", (couponInput.value || "").trim());
      });
    } catch (e) {}
  }

  // intercepta clique no checkout pra aplicar cupom
  var checkoutBtn = root.querySelector(".afb-cta");
  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", function (e) {
      if (!couponInput) return; // segue fluxo normal
      var code = (couponInput.value || "").trim();
      if (!code) return; // segue fluxo normal
      e.preventDefault();
      // aplica no checkout sem depender do "input discount"
      location.href = "/discount/" + encodeURIComponent(code) + "?redirect=/checkout";
    }, true);
  }

  /* ---------- Stepper: criar uma vez por item + remover botão Atualizar ---------- */
  function enhanceLineItem(itemEl) {
    if (!itemEl) return;

    var box = itemEl.querySelector(".afb-qty-box");
    if (!box) return;

    // remove o botão Atualizar se existir
    var upd = box.querySelector(".afb-btn-update");
    if (upd && upd.parentNode) upd.parentNode.removeChild(upd);

    // se já tem stepper, não duplica
    if (box.querySelector(".afb-qty-stepper")) return;

    var input = box.querySelector(".afb-qty-input");
    if (!input) return;

    // remove possíveis controles do tema dentro do box (evita quadradinhos)
    var junk = box.querySelectorAll(
      ".quantity-up,.quantity-down,.qtyplus,.qtyminus,.js-qty,.js-qty__adjust,.plus,.minus"
    );
    for (var j = 0; j < junk.length; j++) {
      if (junk[j] && junk[j].parentNode) junk[j].parentNode.removeChild(junk[j]);
    }

    // cria stepper
    var stepper = document.createElement("div");
    stepper.className = "afb-qty-stepper";

    var bMinus = document.createElement("button");
    bMinus.type = "button";
    bMinus.className = "afb-qty-btn is-minus";
    bMinus.setAttribute("aria-label", "Diminuir quantidade");
    bMinus.textContent = "–";

    var bPlus = document.createElement("button");
    bPlus.type = "button";
    bPlus.className = "afb-qty-btn is-plus";
    bPlus.setAttribute("aria-label", "Aumentar quantidade");
    bPlus.textContent = "+";

    // move input pra dentro do stepper
    stepper.appendChild(bMinus);
    stepper.appendChild(input);
    stepper.appendChild(bPlus);

    // coloca stepper antes do remover
    var removeBtn = box.querySelector(".afb-btn-remove");
    if (removeBtn) box.insertBefore(stepper, removeBtn);
    else box.appendChild(stepper);

    // garante min e inputmode
    input.setAttribute("min", "0");
    input.setAttribute("inputmode", "numeric");
  }

  function enhanceAll() {
    if (!list) return;
    var items = list.querySelectorAll(".afb-cart-item");
    for (var i = 0; i < items.length; i++) enhanceLineItem(items[i]);
  }

  enhanceAll();

  /* ---------- Auto update (debounce por linha) ---------- */
  var timers = Object.create(null);
  var busy = Object.create(null);

  function scheduleUpdate(line, qty) {
    if (!line) return;
    clearTimeout(timers[line]);
    timers[line] = setTimeout(function () {
      doUpdate(line, qty);
    }, 260);
  }

  function doUpdate(line, qty) {
    if (busy[line]) {
      scheduleUpdate(line, qty);
      return;
    }
    busy[line] = true;

    changeLine(line, qty)
      .then(function () { return fetchCart(); })
      .then(function (cart) { syncDomWithCart(cart); })
      .catch(function () {
        // se der ruim, recarrega pra não ficar incoerente
        location.reload();
      })
      .finally(function () {
        busy[line] = false;
      });
  }

  /* clique no + / - */
  root.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest(".afb-qty-btn");
    if (!btn) return;

    var stepper = btn.closest(".afb-qty-stepper");
    if (!stepper) return;

    var input = stepper.querySelector(".afb-qty-input");
    if (!input) return;

    var item = btn.closest(".afb-cart-item");
    var line = parseInt((input.dataset.line || (item && item.dataset.line) || "0"), 10);
    if (!line) return;

    var current = parseInt(input.value || "0", 10);
    if (isNaN(current)) current = 0;

    var next = current + (btn.classList.contains("is-plus") ? 1 : -1);
    if (next < 0) next = 0;

    input.value = String(next);
    scheduleUpdate(line, next);
  }, true);

  /* mudança manual no input */
  root.addEventListener("input", function (e) {
    var input = e.target && e.target.classList && e.target.classList.contains("afb-qty-input") ? e.target : null;
    if (!input) return;

    var item = input.closest(".afb-cart-item");
    var line = parseInt((input.dataset.line || (item && item.dataset.line) || "0"), 10);
    if (!line) return;

    var qty = parseInt(input.value || "0", 10);
    if (isNaN(qty) || qty < 0) qty = 0;

    scheduleUpdate(line, qty);
  }, true);

  /* remover sem recarregar + sem buraco */
  root.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest("a.afb-btn-remove");
    if (!a) return;

    var item = a.closest(".afb-cart-item");
    if (!item) return;

    var line = parseInt(item.dataset.line || "0", 10);
    if (!line) return;

    e.preventDefault();

    item.classList.add("is-removing");
    setTimeout(function () {
      changeLine(line, 0)
        .then(function () { return fetchCart(); })
        .then(function (cart) {
          // remove do DOM e sincroniza
          if (item && item.parentNode) item.parentNode.removeChild(item);
          syncDomWithCart(cart);
        })
        .catch(function () { location.reload(); });
    }, 180);
  }, true);

  /* primeira sincronização: corrige preço “0” e garante totals */
  fetchCart().then(syncDomWithCart).catch(function(){});
})();

;(function () {
  if (window.AFB_GIFT_PREVIEW_V3D_LOADED) return;
  window.AFB_GIFT_PREVIEW_V3D_LOADED = true;

  var TIERS = [
    { minCents: 200000, giftLabel: "1 Funko Pop Original", collection: "/collections/funko/products.json?limit=250" },
    { minCents: 150000, giftLabel: "1 PopChain (Chaveiro Funko Pop)", collection: "/collections/chaveiro-funko-pop/products.json?limit=250" },
    { minCents: 100000, giftLabel: "1 Chaveiro ActionFigureBrasil + 1 HQ Panini", collection: "" },
    { minCents: 0,      giftLabel: "1 Chaveiro ActionFigureBrasil", collection: "" }
  ];

  function pickTier(c){
    for (var i=0;i<TIERS.length;i++) if (c >= TIERS[i].minCents) return TIERS[i];
    return TIERS[TIERS.length-1];
  }

  function getVisiblePreview(){
    var list = document.querySelectorAll("[data-afb-gift-preview]");
    if (!list || !list.length) return null;
    for (var i=0;i<list.length;i++){
      if (list[i].offsetParent !== null) return list[i];
    }
    return list[0];
  }

  function getWrapFromPreview(preview){
    if (!preview) return null;
    return preview.closest(".afb-gift-wrap") || null;
  }

  function findVariantId() {
    var el = document.querySelector('input[name="id"], select[name="id"]');
    if (el && el.value) {
      var n = parseInt(el.value, 10);
      if (!isNaN(n)) return n;
    }
    var sp = new URLSearchParams(location.search || "");
    var qv = sp.get("variant");
    if (qv) {
      var nq = parseInt(qv, 10);
      if (!isNaN(nq)) return nq;
    }
    return null;
  }

  function getHandle() {
    var m = (location.pathname || "").match(/\/products\/([^\/\?]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  // ---- product.js cache
  var PRODUCT_CACHE = null;
  var PRODUCT_PROMISE = null;

  function loadProductJs() {
    if (PRODUCT_CACHE) return Promise.resolve(PRODUCT_CACHE);
    if (PRODUCT_PROMISE) return PRODUCT_PROMISE;

    var handle = getHandle();
    if (!handle) return Promise.reject(new Error("no_handle"));

    PRODUCT_PROMISE = fetch("/products/" + encodeURIComponent(handle) + ".js", {
      credentials: "same-origin",
      cache: "force-cache"
    })
    .then(function(r){ if(!r.ok) throw new Error("fetch_fail"); return r.json(); })
    .then(function(json){ PRODUCT_CACHE = json; return json; })
    .catch(function(e){ PRODUCT_PROMISE = null; throw e; });

    return PRODUCT_PROMISE;
  }

  function getPriceFromProductJson(pj, variantId){
    if (!pj || !pj.variants || !pj.variants.length) return null;
    var v = null;

    if (variantId) {
      for (var i=0;i<pj.variants.length;i++){
        if (pj.variants[i].id === variantId) { v = pj.variants[i]; break; }
      }
    }
    if (!v) v = pj.variants[0];

    if (v && typeof v.price === "number") return v.price;
    if (v && v.price != null) {
      var n = parseInt(v.price, 10);
      if (!isNaN(n)) return n;
    }
    return null;
  }

  // ---- imagem dinâmica (cache sessionStorage)
  function pickRandom(arr){
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function getCachedImg(key){
    try { return sessionStorage.getItem(key) || ""; } catch(e){ return ""; }
  }
  function setCachedImg(key, val){
    try { sessionStorage.setItem(key, val); } catch(e){}
  }

  function fetchRandomImageFromCollection(url, cacheKey){
    var cached = getCachedImg(cacheKey);
    if (cached) return Promise.resolve(cached);

    return fetch(url, { credentials: "same-origin", cache: "force-cache" })
      .then(function(r){ if(!r.ok) throw new Error("col_fail"); return r.json(); })
      .then(function(json){
        var products = (json && json.products) ? json.products : [];
        var imgs = [];

        for (var i=0;i<products.length;i++){
          var p = products[i];
          // products.json costuma ter images: [{src:...}] ou image:{src:...}
          if (p && p.image && p.image.src) imgs.push(p.image.src);
          if (p && p.images && p.images.length && p.images[0].src) imgs.push(p.images[0].src);
        }

        imgs = imgs.filter(Boolean);
        if (!imgs.length) return "";

        var picked = pickRandom(imgs);
        setCachedImg(cacheKey, picked);
        return picked;
      })
      .catch(function(){ return ""; });
  }

  function renderGift(cents){
    var preview = getVisiblePreview();
    if (!preview) return false;

    var wrap = getWrapFromPreview(preview);
    if (!wrap) return false;

    var text = wrap.querySelector("[data-afb-gift-text]");
    if (!text) return false;

    var tier = pickTier(cents || 0);
    var newText = "Adquira este produto e receba " + tier.giftLabel + " de brinde";
    if (text.textContent !== newText) text.textContent = newText;

    preview.style.display = "flex";
    preview.dataset.afbGiftApplied = "1";

    // --- card daquela instância
    var card = wrap.querySelector("[data-afb-gift-card]");
    if (!card) return true;

    // mobile: não mostra card
    if (window.matchMedia && window.matchMedia("(max-width: 991.98px)").matches){
      card.style.display = "none";
      return true;
    }

    var cap = card.querySelector("[data-afb-gift-cap]");
    if (cap && cap.textContent !== tier.giftLabel) cap.textContent = tier.giftLabel;

    var img = card.querySelector("img[data-afb-gift-img]");

    // só tiers com coleção ganham imagem/card
    if (!tier.collection){
      card.style.display = "none";
      if (img) img.removeAttribute("src");
      return true;
    }

    var cacheKey = "AFB_GIFTIMG_" + tier.minCents;
    fetchRandomImageFromCollection(tier.collection, cacheKey).then(function(src){
      if (!src){
        card.style.display = "none";
        if (img) img.removeAttribute("src");
        return;
      }
      if (img && img.getAttribute("src") !== src) img.setAttribute("src", src);
      card.style.display = "block";   // ✅ LIGA o card
      card.setAttribute("aria-hidden","true");
    });

    return true;
  }

  function applyGift(){
    var variantId = findVariantId();

    // 1) window.AFB_PRODUCT
    var p = window.AFB_PRODUCT;
    if (p && p.variants && p.variants.length) {
      var cents = null;
      for (var i=0;i<p.variants.length;i++){
        if (variantId && p.variants[i].id === variantId) { cents = p.variants[i].price; break; }
      }
      if (cents == null) cents = p.variants[0] && p.variants[0].price;
      if (typeof cents === "number") return renderGift(cents);
    }

    // 2) /products/handle.js
    loadProductJs().then(function(pj){
      var cents2 = getPriceFromProductJson(pj, variantId);
      if (cents2 != null) renderGift(cents2);
    }).catch(function(){});

    return false;
  }

  function boot(){
    var tries = 0;
    var timer = setInterval(function(){
      tries++;
      applyGift();
      if (document.querySelector('[data-afb-gift-preview][data-afb-gift-applied="1"]')) clearInterval(timer);
      if (tries >= 80) clearInterval(timer);
    }, 120);
  }

  function observeRerender(){
    var target = document.querySelector(".afb-price-box") || document.body;
    if (!target) return;
    var mo = new MutationObserver(function(){ applyGift(); });
    mo.observe(target, { childList:true, subtree:true, characterData:true });
  }

  function init(){
    var preview = getVisiblePreview();
    if (!preview) return;

    if (preview.dataset.afbGiftInit === "1") return;
    preview.dataset.afbGiftInit = "1";

    boot();
    observeRerender();
    applyGift();

    window.AFB_GIFT_PREVIEW_FORCE = applyGift;
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();

(function(){
  if (window.AFB_HEADER_SHRINK_V4) return;
  window.AFB_HEADER_SHRINK_V4 = true;

  function isScrollable(el){
    if (!el || el === document.documentElement) return false;
    var st = el.scrollHeight - el.clientHeight;
    if (st < 16) return false;
    var cs = getComputedStyle(el);
    return /(auto|scroll|overlay)/.test(cs.overflowY || '');
  }

  function findScrollParent(from){
    var el = from;
    while (el && el !== document.body){
      if (isScrollable(el)) return el;
      el = el.parentElement;
    }
    // fallbacks comuns do seu tema
    return (
      document.querySelector('.afb-page-wrapper') ||
      document.querySelector('.wrapper') ||
      document.scrollingElement ||
      document.documentElement
    );
  }

  function init(){
    var header = document.querySelector('.header-inner');
    if (!header) return;

    // evita duplicar
    if (header.dataset.afbShrinkBound === '1') return;
    header.dataset.afbShrinkBound = '1';

    var spacer = document.querySelector('.headerSpace.visible') || document.querySelector('.headerSpace');
    var scrollEl = null;
    var last = null;

    function getScrollTop(){
      // prioridade: elemento scroll real
      if (scrollEl && scrollEl !== document.documentElement && scrollEl !== document.body){
        return scrollEl.scrollTop || 0;
      }
      // window/document
      return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    }

    function syncSpacer(){
      if (!spacer) return;
      // atualiza o “headerSpace” pra acompanhar a altura nova
      requestAnimationFrame(function(){
        spacer.style.height = header.offsetHeight + 'px';
      });
    }

    function apply(){
      var y = getScrollTop();
      var sc = y > 14;

      if (sc === last) return;
      last = sc;

      header.classList.toggle('is-scrolled', sc);
      syncSpacer();
    }

    function bindTo(el){
      if (!el) return;
      if (scrollEl === el) return;
      scrollEl = el;

      // garante atualização imediata
      apply();

      // listeners (el + window)
      try{
        el.addEventListener('scroll', apply, { passive: true });
      }catch(e){
        el.addEventListener('scroll', apply);
      }
    }

    // 1) tenta os alvos mais prováveis
    var candidates = [
      document.querySelector('.afb-page-wrapper'),
      document.querySelector('.wrapper'),
      document.scrollingElement,
      document.documentElement,
      document.body
    ].filter(Boolean);

    // escolhe primeiro scrollável
    var picked = candidates.find(isScrollable) || document.scrollingElement || document.documentElement;
    bindTo(picked);

    // 2) fallback inteligente: detecta o scroll real pelo wheel/touch
    function detectFromEvent(e){
      var t = e.target;
      if (t && t.nodeType === 3) t = t.parentElement;
      var p = findScrollParent(t || document.body);
      bindTo(p);
      apply();
    }

    document.addEventListener('wheel', detectFromEvent, { passive: true, capture: true });
    document.addEventListener('touchmove', detectFromEvent, { passive: true, capture: true });

    // 3) também atualiza no resize (header muda altura em responsive)
    window.addEventListener('resize', function(){
      syncSpacer();
      apply();
    }, { passive: true });

    // primeira aplicação
    apply();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

/* =========================================================
   AFB — LOGIN RETURN FORCE (V3)
   - Salva URL atual em sessionStorage
   - No /account/login, injeta return_to no FORM
   - Ganha de redirect fixo tipo /collections/all
========================================================= */
(function(){
  if (window.AFB_LOGIN_RETURN_FORCE_V3) return;
  window.AFB_LOGIN_RETURN_FORCE_V3 = true;

  const KEY = "afb_return_to";

  function safePath(u){
    try{
      const url = new URL(u, location.origin);
      if (url.origin !== location.origin) return "";
      return url.pathname + url.search + url.hash;
    }catch(e){ return ""; }
  }

  function isBadToSave(path){
    return (
      path.indexOf("/account") === 0 ||
      path.indexOf("/cart") === 0 ||
      path.indexOf("/checkout") === 0 ||
      path.indexOf("/challenge") === 0
    );
  }

  function saveCurrent(){
    try{
      if(!isBadToSave(location.pathname)){
        sessionStorage.setItem(KEY, location.pathname + location.search + location.hash);
      }
    }catch(e){}
  }

  // 1) salva sempre que navegar em páginas normais
  saveCurrent();

  // 2) ao clicar em "entrar", salva a página atual
  document.addEventListener("click", function(e){
    const a = e.target && e.target.closest ? e.target.closest("a") : null;
    if(!a) return;

    const href = (a.getAttribute("href") || "").trim();
    if(!href) return;

    if (href === "/account/login" || href.indexOf("/account/login?") === 0 || a.hasAttribute("data-afb-login")){
      saveCurrent();
    }
  }, true);

  // 3) se estou na página de login, força return_to no form
  function forceReturnToInLoginForm(){
    if (location.pathname.indexOf("/account/login") !== 0) return;

    let rt = "";
    try{ rt = sessionStorage.getItem(KEY) || ""; }catch(e){}
    rt = safePath(rt);

    if(!rt) return;

    // não deixa voltar pro próprio /account/login
    if (rt.indexOf("/account/login") === 0) return;

    const forms = Array.from(document.querySelectorAll("form"));
    if(!forms.length) return;

    forms.forEach(form=>{
      // tenta achar o input certo
      let input =
        form.querySelector("#afbReturnTo") ||
        form.querySelector("input[name='return_to']") ||
        form.querySelector("input[name='return_url']") ||
        form.querySelector("input[name='checkout_url']");

      if(!input){
        input = document.createElement("input");
        input.type = "hidden";
        input.name = "return_to";
        input.id = "afbReturnTo";
        form.appendChild(input);
      }

      // força o valor
      input.value = rt;

      // reforço no submit (caso outro script altere)
      if(!form._afbReturnBound){
        form._afbReturnBound = true;
        form.addEventListener("submit", ()=>{
          try{
            const i = form.querySelector("#afbReturnTo") || form.querySelector("input[name='return_to']");
            if(i) i.value = rt;
          }catch(e){}
        }, true);
      }
    });
  }

  // roda agora e depois (tema às vezes renderiza form depois)
  forceReturnToInLoginForm();
  setTimeout(forceReturnToInLoginForm, 50);
  setTimeout(forceReturnToInLoginForm, 250);
  setTimeout(forceReturnToInLoginForm, 800);

})();
